<template>
  <v-layout>
    <div class="modal">
      <v-dialog
        :value="value"
        persistent
        @input="$emit('input')"
        transition="fade-transition"
        fullscreen
        no-click-animation
        content-class="ims-standard-dialog"
      >
        <v-card class="ims-modal-card">
          <v-toolbar class="pairing-modal-toolbar" color="#3F3FFF" dark :elevation="1">
              <v-toolbar-title class="pairing-modal-title-wrap">
                <h3 class="text-xs-center white--text pairing-modal-title" style="font-size:1.25rem;">
                  Pair influencers for campaign:
                  <strong>{{ campaign.name }}</strong>
                </h3>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="close" class="pairing-modal-close" aria-label="Close">
                <v-icon>mdi-close</v-icon>
              </v-btn>
          </v-toolbar>
          <div class="modal-content ims-modal-body">
            <v-container fluid>
              <v-layout column>
                <v-row>
                  <v-col cols="12" sm="12" md="3" xs="12">
                    <v-hover v-slot:default="{ hover }">
                      <v-card
                        color="#363636"
                        dark
                        :elevation="hover ? 12 : 2"
                        :class="{ 'on-hover': hover }"
                      >
                        <v-card-title class="headline">Contents</v-card-title>
                        <v-card-subtitle>
                          <p
                            class="pa-0 ma-0 custom-font"
                          >Target : {{ campaign.min_content }} to {{ campaign.max_content }}</p>
                          <p class="pa-0 ma-0 custom-font">Current Total: {{measurement.total}}</p>
                          <p
                            class="pa-0 ma-0 custom-font"
                          >Percentage: {{measurement.totalPercentage}}%</p>
                        </v-card-subtitle>
                      </v-card>
                    </v-hover>
                  </v-col>
                  <v-col cols="12" sm="12" md="3" xs="12">
                    <v-hover v-slot:default="{ hover }">
                      <v-card
                        color="#363636"
                        dark
                        :elevation="hover ? 12 : 2"
                        :class="{ 'on-hover': hover }"
                      >
                        <v-card-title class="headline">Outreach</v-card-title>
                        <v-card-subtitle>
                          <p
                            class="pa-0 ma-0 custom-font"
                          >Target : {{ campaign.outreach | thousandSeprator}}</p>
                          <p
                            class="pa-0 ma-0 custom-font"
                          >Current Total: {{measurement.outreach | thousandSeprator}}</p>
                          <p
                            class="pa-0 ma-0 custom-font"
                          >Percentage: {{measurement.outreachPercentage}}%</p>
                        </v-card-subtitle>
                      </v-card>
                    </v-hover>
                  </v-col>
                  <v-col cols="12" sm="12" md="3" xs="12">
                    <v-hover v-slot:default="{ hover }">
                      <v-card
                        color="#363636"
                        dark
                        :elevation="hover ? 12 : 2"
                        :class="{ 'on-hover': hover }"
                      >
                        <v-card-title class="headline">Engagement</v-card-title>
                        <v-card-subtitle>
                          <p
                            class="pa-0 ma-0 custom-font"
                          >Target : {{ campaign.engagement | thousandSeprator}}</p>
                          <p
                            class="pa-0 ma-0 custom-font"
                          >Current Total: {{measurement.engagement | thousandSeprator}}</p>
                          <p
                            class="pa-0 ma-0 custom-font"
                          >Percentage: {{measurement.engagementPercentage}}%</p>
                        </v-card-subtitle>
                      </v-card>
                    </v-hover>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-hover v-slot:default="{ hover }">
                      <v-card
                        color="#363636"
                        dark
                        :elevation="hover ? 12 : 2"
                        :class="{ 'on-hover': hover }"
                      >
                        <v-card-title class="headline">COGS</v-card-title>
                        <v-card-subtitle>
                          <p class="pa-0 ma-0 custom-font">Capped : {{ budget | currency }}</p>
                          <p class="pa-0 ma-0 custom-font">Current: {{ measurement.budget | currency }}</p>
                          <span v-for="(item, index) in currencyTotals" :key="index">
                            <p class="pa-0 ma-0 custom-font" v-if="index !== 'SGD' && item">Total {{index}}: {{utilsFunc.currencySym(index)}} {{item | thousandSeprator}}</p>
                          </span>
                          <p
                            class="pa-0 ma-0 custom-font"
                          >Percentage: {{measurement.cogsPercentage}}%</p>
                        </v-card-subtitle>
                      </v-card>
                    </v-hover>
                  </v-col>
                </v-row>
                <v-row style="justify-content:center;">
                  <!-- <v-col col-md-6 col-xs-12 align="center">
                    <h3 class="mb-1">
                      Influencers suggested by AI
                      <v-btn icon @click="enableSettingForAI()" color="secondary">
                        <v-icon>mdi-filter-menu-outline</v-icon>
                      </v-btn>
                    </h3>
                    <p v-if="!suggestedInfluencers || suggestedInfluencers.length === 0">
                      <i>There are no influencers to suggest for this campaign brief!</i>
                    </p>
                    <v-chip
                      v-for="(item) in suggestedInfluencers"
                      :key="item.userHandle"
                      class="ma-2"
                      filter
                      :color="isSelected(item.userHandle, item.platform) ? 'green' : ''"
                      outlined
                      @click="select(item.userHandle, item.platform)"
                    >
                      <v-icon left>mdi-account-circle-outline</v-icon>
                      @{{item.userHandle}}
                    </v-chip>
                    <div>
                      <v-btn
                        class="mt-1"
                        v-if="!loadingAI && suggestedInfluencers && suggestedInfluencers.length > 0"
                        rounded
                        color="secondary"
                        @click="getSuggestedInfluencerFromAI(campaign.id, true)"
                        outlined
                      >Load more</v-btn>
                      <v-progress-circular
                        v-if="loadingAI"
                        :size="50"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-col>
                  <v-divider vertical></v-divider> -->
                  <v-col class="col-md-12 col-xs-12" align="center">
                    <!-- <v-radio-group row v-model="searchType">
                      <v-radio
                        color="success"
                        label="Search by Handle"
                        :value="SearchTypeEnum.HANDLE"
                      ></v-radio>
                      <v-radio
                        color="success"
                        label="Search by keyword"
                        :value="SearchTypeEnum.KEYWORD"
                      ></v-radio>
                      <v-radio
                        color="success"
                        label="Bulk Upload"
                        :value="SearchTypeEnum.BULKUPLOAD"
                      ></v-radio>
                    </v-radio-group> -->
                    <div class="d-flex flex-row">
                      <h3 class="mr-5 pa-2 pt-1">Add Creators</h3>
                      <v-select
                        class="mt-3"
                        style="max-width: 250px;margin-right: 10px;"
                        v-model="searchType"
                        :items="searchMethods"
                        outlined
                        attach
                      ></v-select>
                      <v-text-field
                        :label="searchInfluencer === 'Youtube' ? 'Enter Handle' : 'Enter handle'"
                        v-if="searchType === SearchTypeEnum.HANDLE"
                        style=""
                        hide-details
                        v-model="igHandle"
                        @keyup.enter.native="searchManually(searchType)"
                        class="mt-3 pr-2"
                        outlined
                      ></v-text-field>
                      <v-select
                        class="mt-3 mr-2"
                        style="max-width: 200px;"
                        v-model="searchInfluencer"
                        :items="searchInfluencerTypes"
                        item-text="text"
                        item-value="value"
                        v-if="searchType === SearchTypeEnum.HANDLE"
                        outlined
                        attach
                      >
                        <template v-slot:selection="{ item }">
                          <img v-if="item.imgIcon" :src="item.imgIcon" width="20px" class="mr-2" :style="item.iconFilter ? `filter: ${item.iconFilter} !important;` : ''" alt="" aria-hidden="true" />
                          <v-icon v-else class="mr-2" size="20" :style="`color: ${item.iconColor} !important;`">{{ item.icon }}</v-icon>
                          <span>{{ item.text }}</span>
                        </template>
                        <template v-slot:item="{ item }">
                          <img v-if="item.imgIcon" :src="item.imgIcon" width="20px" class="mr-2" :style="item.iconFilter ? `filter: ${item.iconFilter} !important;` : ''" alt="" aria-hidden="true" />
                          <v-icon v-else class="mr-2" size="20" :style="`color: ${item.iconColor} !important;`">{{ item.icon }}</v-icon>
                          <span>{{ item.text }}</span>
                        </template>
                      </v-select>
                      <v-text-field
                        label="Enter Platform Name"
                        v-if="searchType === SearchTypeEnum.HANDLE && searchInfluencer === 'Others'"
                        hide-details
                        v-model="platformName"
                        @keyup.enter.native="searchManually(searchType)"
                        class="mt-3 mr-2 pl-2"
                        outlined
                      ></v-text-field>
                      <k-influencer-search-box
                        v-if="searchType === SearchTypeEnum.KEYWORD"
                        :search="searchKeywordAction"
                        @result="resultFromSearchKeyword"
                      ></k-influencer-search-box>
                      <v-btn
                        :disabled="!historySearchResult"
                        color="secondary"
                        v-if="searchType === SearchTypeEnum.KEYWORD"
                        class="mt-5 mr-2"
                        style="min-height:40px;"
                        @click="showResult(historySearchResult)"
                      >View results</v-btn>
                      <v-btn class="mt-4" color="secondary" @click="$refs.igBulkHandle.click()" v-if="searchType === SearchTypeEnum.BULKUPLOAD" large>
                        <v-icon left>mdi-home-import-outline</v-icon>Import Excel
                      </v-btn>
                      <v-btn color="secondary" class="ml-2 mt-4" @click="downloadSampleUpload" v-if="searchType === SearchTypeEnum.BULKUPLOAD" large>
                        <v-icon left>mdi-file-excel</v-icon>Download Sample Import
                      </v-btn>
                      <v-btn color="secondary" class="mt-5" style="min-width:150px;min-height:40px;" @click="searchManually(searchType)" v-if="searchType !== SearchTypeEnum.BULKUPLOAD">ADD</v-btn>
                    </div>
                    <input
                      type="file"
                      accept=".xlsx"
                      id="igBulkHandle"
                      ref="igBulkHandle"
                      style="display: none"
                      @change="igHandleBulkUpload"
                    />
                  </v-col>
                </v-row>
                
                <v-row class="pairing-control-row" align="center">
                  <v-col class="pairing-primary-controls" cols="12" sm="12" md="7" lg="7">
                    <div class="pairing-toolbar-actions">
                      <v-chip class="pairing-toolbar-chip" color="error" v-if="disableLockedCOGS">
                        <v-icon v-on="on" small left>mdi-lock</v-icon>Locked COGS
                      </v-chip>
                      <v-btn
                        small
                        color="secondary"
                        class="pairing-toolbar-btn"
                        @click="openLockedCOGSDialog(campaign)"
                        v-if="!isAdmin && disableLockedCOGS"
                      >
                        <v-icon small>mdi-lock-open</v-icon> Request Unlock
                      </v-btn>
                      <v-btn
                        color="secondary"
                        class="pairing-toolbar-btn"
                        @click="changeLock(campaign, false)"
                        v-if="isAdmin && disableLockedCOGS"
                      >
                        <v-icon small>mdi-lock-open</v-icon> Unlock
                      </v-btn>
                      <v-btn
                        color="secondary"
                        class="pairing-toolbar-btn"
                        @click="changeLock(campaign, true)"
                        v-if="showLockBtn"
                      >
                        <v-icon small>mdi-lock</v-icon> Lock
                      </v-btn>
                      <download-excel
                        v-if="items && items.length > 0"
                        class="download-excel-secondary pairing-toolbar-download"
                        :data="items"
                        :fields="json_fields"
                        worksheet="Predicted price"
                        name="pairing.xls"
                      >Download Excel</download-excel>
                      <v-menu offset-y left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          color="secondary"
                          class="pairing-toolbar-btn"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="actionSelected.length === 0 || disableLockedCOGS"
                        >
                          <v-icon small left>mdi-format-list-bulleted</v-icon>
                          Bulk Action
                          <span v-if="actionSelected.length" class="ml-1">({{ actionSelected.length }})</span>
                          <v-icon small right>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense class="pairing-bulk-action-menu">
                        <v-list-item @click="confirmDelete">
                          <v-list-item-icon><v-icon color="error" small>mdi-delete</v-icon></v-list-item-icon>
                          <v-list-item-title>Delete</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="changeBulkPairingStatus(pairingStatus.ACCEPTED.value)">
                          <v-list-item-icon><v-icon color="secondary" small>mdi-check-circle</v-icon></v-list-item-icon>
                          <v-list-item-title>Accept</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="changeBulkPairingStatus(pairingStatus.NOT_ACCEPTED.value)">
                          <v-list-item-icon><v-icon color="error" small>mdi-close-circle</v-icon></v-list-item-icon>
                          <v-list-item-title>Not Accept</v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item @click="openDeliverableUpdateDialog()">
                          <v-list-item-icon><v-icon color="secondary" small>mdi-pencil-box-multiple</v-icon></v-list-item-icon>
                          <v-list-item-title>Update Deliverables</v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item @click="moveOption(0)">
                          <v-list-item-icon><v-icon color="secondary" small>mdi-arrow-left-bold-circle</v-icon></v-list-item-icon>
                          <v-list-item-title>Move to Option A</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="moveOption(1)">
                          <v-list-item-icon><v-icon color="secondary" small>mdi-arrow-right-bold-circle</v-icon></v-list-item-icon>
                          <v-list-item-title>Move to Option B</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="moveAllOption(0)">
                          <v-list-item-icon><v-icon color="secondary" small>mdi-arrow-collapse-left</v-icon></v-list-item-icon>
                          <v-list-item-title>Move All to Option A</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="moveAllOption(1)">
                          <v-list-item-icon><v-icon color="secondary" small>mdi-arrow-collapse-right</v-icon></v-list-item-icon>
                          <v-list-item-title>Move All to Option B</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                      <v-btn color="secondary" class="pairing-toolbar-btn" v-if="!disableSaveLineUp" @click="saveLineUp" small>Save LineUp</v-btn>
                    </div>
                  </v-col>
                  <v-col class="pairing-search-controls" cols="12" sm="12" md="5" lg="5" v-if="!disableSaveEdit">
                    <div class="pairing-edit-actions" v-if="!disableSaveEdit">
                      <v-btn class="secondary--text" @click="cancelEdit" small>Cancel</v-btn>
                      <v-btn color="secondary" @click="saveEditingData" small>Save Changes</v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-0 pairing-filter-row">
                  <v-col class="mt-3" cols="12" sm="12" md="12" lg="12">
                    <v-row >
                      <v-col cols="12" sm="12" md="8" lg="8" >
                        <v-col style="max-width:70px" cols="12" sm="12" md="1" lg="1" align="right">
                          <label style="padding-top:10px;">
                            Filters:
                          </label>
                        </v-col>
                        <v-col cols="12" sm="12" md="2" lg="2" >
                          <v-select
                            v-model="searchPairingStatus"
                            :items="filterPairingStatusOptions"
                            item-value="status"
                            item-text="display"
                            label="Pairing Status"
                            @change="pairingStatusOnChangeHandler"
                            dense
                            solo
                            attach
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="2" lg="2" >
                          <v-select
                            v-model="searchGender"
                            :items="genderItems"
                            label="Gender"
                            @change="genderOnChangeHandler"
                            dense
                            solo
                            attach
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="1" lg="1" >
                          <v-select
                            v-model="searchAge"
                            :items="ageItems"
                            label="Age Group"
                            @change="ageOnChangeHandler"
                            dense
                            solo
                            attach
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="2" lg="2" >
                          <v-select
                            v-model="searchLocation"
                            :items="locationItems"
                            label="Location"
                            @change="countryOnChangeHandler"
                            dense
                            solo
                            attach
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="2" lg="2" >
                          <v-select
                            v-model="searchAudCrediblity"
                            :items="audCrediblityFilters"
                            item-text="name"
                            label="Audience Cred."
                            @change="pairingStatusOnChangeHandler"
                            dense
                            solo
                            attach
                          ></v-select>
                        </v-col>
                        <v-col style="max-width:92px" cols="12" sm="12" md="1" lg="1" >
                          <v-btn @click="clearFilter" color="secondary">Clear</v-btn>
                        </v-col>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4" class="pairing-table-tools" v-if="this.campaign.pairingDisplayStatus">
                        <v-text-field
                          class="pairing-table-search"
                          v-model="searchFilter"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                        <v-menu
                          class="menu-pairing"
                          :close-on-content-click="false"
                          bottom
                          left
                          max-height="500px"
                          style="max-height:500px;min-height:500px;"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="mt-3"
                              icon
                              color="secondary"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item v-for="(field, index) in showHideFields" :key="index">
                              <v-checkbox
                                v-model="campaign.pairingDisplayStatus[field.name]"
                                :label="field.label"
                                color="secondary"
                                :true-value="true"
                                :false-value="false"
                                hide-details
                                @change="updatePairingDisplayStatus"
                              ></v-checkbox>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-btn
                          icon
                          class="mt-3"
                          color="secondary"
                          :title="showFrozenPairingColumns ? 'Hide frozen columns' : 'Show frozen columns'"
                          :aria-label="showFrozenPairingColumns ? 'Hide frozen columns' : 'Show frozen columns'"
                          :aria-pressed="String(showFrozenPairingColumns)"
                          @click="showFrozenPairingColumns = !showFrozenPairingColumns"
                        >
                          <v-icon>{{ showFrozenPairingColumns ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :headers="filteredHeaders"
                      :items="items"
                      item-key="dataTableKey"
                      :search="searchFilter"
                      :items-per-page="20"
                      :no-data-text="'Empty list'"
                      class="elevation-1 page__table pairing-freeze-table"
                      :class="{ 'pairing-freeze-active': showFrozenPairingColumns && displayFields('AIPayout') && displayFields('payout') && displayFields('pairingStatus') }"
                      show-select
                      :single-select="false"
                      :mobile-breakpoint="0"
                      v-model="selectAllStatus"
                      @update:page="updatePagination"
                      @toggle-select-all="selectAllPairings"
                    >
                      <template v-slot:body="props">
                        <draggable
                        :list="props.items"
                        tag="tbody"
                        @update="handleTableUpdate(props.items)" >
                          <tr
                            v-for="(item, parentIndex) in props.items"
                            :key="item.instagram"
                            v-bind:class="{'danger': (!item.success || item.eliminationStatus === eliminationStatus.ELIMINATED) && !item.isLoading}"
                          >
                            <td style="min-width:100px;padding: 0 14px!important;">
                              <v-icon
                                small
                                class="move-cursor"
                              >
                                mdi-arrow-all
                              </v-icon>
                              <v-progress-circular
                                v-if="item.isLoading"
                                :width="2"
                                color="green"
                                indeterminate
                              ></v-progress-circular>
                              <v-checkbox
                                class="multi-select-checkbox"
                                v-model="item.isDelete"
                                label=""
                                color="grey darken-2"
                                @change="actionSelectChange"
                                :disabled="item.payoutStatus == payoutStatus.CONFIRMED"
                              ></v-checkbox>
                              <v-tooltip bottom v-if="item.platform !== 'others'">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    class="btn-reload"
                                    text
                                    x-small
                                    color="secondary"
                                    @click="executeMethod('refresh', item)"
                                    v-on="on"
                                  >
                                    <v-icon small>
                                      mdi-reload
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Click to refresh data</span>
                              </v-tooltip>
                            </td>
                            <td style="min-width:150px;max-width:150px" align="center" v-if="displayFields('lastReportDate')">
                              <span v-if="item.lastReportDate">{{ utilsFunc.formatCustomDate(item.lastReportDate, 'DD/MM/YYYY') }}</span>
                            </td>
                            <td style="min-width:200px;max-width:200px" align="left" v-if="displayFields('influencer')">
                              <!-- <a
                                :href="'https://www.tiktok.com/@' + item.userHandle"
                                target="_blank"
                                v-if="item.platform === 'tiktok'"
                              ><img src="/static/img/tiktok-32.png" width="20px" /> @{{item.userHandle}}</a>
                              <a
                                :href="'https://www.instagram.com/' + item.userHandle"
                                target="_blank"
                                v-else
                              ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{item.userHandle}}</a> -->
                              <social-handle
                                divClassName="d-inline"
                                :isTikTok="item.platform === 'tiktok'"
                                :isInstagram="item.platform === 'instagram'"
                                :isFacebook="item.platform === 'facebook'"
                                :isLinkedIn="item.platform === 'linkedin'"
                                :isTwitter="item.platform === 'twitter'"
                                :isYoutube="item.platform === 'youtube'"
                                :isXiaohongshu="item.platform === 'xiaohongshu'"
                                :isOthers="item.platform === 'others'"
                                :tiktokHandle="item.userHandle"
                                :instagramHandle="item.userHandle"
                                :facebookHandle="item.userHandle"
                                :linkedinHandle="item.userHandle"
                                :twitterHandle="item.userHandle"
                                :youtubeHandle="item.userHandle"
                                :xiaohongshuHandle="item.xhsID"
                                :xiaohongshuFullName="item.fullName"
                                :youtubeURL="item.url"
                                :otherHandle="item.userHandle"
                              />
                              <v-menu
                                bottom
                                origin="center center"
                                transition="scale-transition"
                                style="max-height:500px"
                                v-if="item.multipleInfs && item.multipleInfs.length > 1"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    text
                                    v-bind="attrs"
                                    v-on="on"
                                    style="min-width:0;padding:0;margin-left:-9px;margin-top:-3px;"
                                   color="secondary">
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-icon class="ml-2" color="secondary" v-on="on" small>mdi-chevron-down-circle</v-icon>
                                      </template>
                                      <span>Multiple Accounts detected</span>
                                    </v-tooltip>
                                  </v-btn>
                                </template>
                                <v-list>
                                  <v-list-item
                                    v-for="(obj, i) in item.multipleInfs"
                                    :key="i"
                                    link
                                    @click="changePlatform(item.userHandle, obj.handle, obj.platform, item.pairingID)"
                                  >
                                    <v-list-item-title>
                                      <!-- <v-avatar size="35" color="grey lighten-4">
                                        <img
                                          class="elevation-6"
                                          v-bind:src="paserImageUrl(obj.picture)"
                                          alt="avatar"
                                        >
                                      </v-avatar> -->
                                      <a
                                        v-if="obj.xhs"
                                      ><img src="/static/img/xhs-black.png" width="20px" style="filter:invert(27%) sepia(87%) saturate(4714%) hue-rotate(340deg) brightness(103%) contrast(103%) !important;" /> @{{obj.handle}}</a>
                                      <a
                                        v-else-if="obj.facebook"
                                      ><v-icon small style="color:#1877F2 !important;">mdi-facebook</v-icon> @{{obj.handle}}</a>
                                      <a
                                        v-else-if="obj.linkedin"
                                      ><v-icon small style="color:#0A66C2 !important;">mdi-linkedin</v-icon> @{{obj.handle}}</a>
                                      <a
                                        v-else-if="obj.twitter"
                                      ><img src="/static/img/x-logo.svg" width="15px" alt="X (Twitter)" /> @{{obj.handle}}</a>
                                      <a
                                        v-else-if="obj.tiktok"
                                      ><img src="/static/img/tiktok-32.png" width="20px" /> @{{obj.handle}}</a>
                                      <a
                                        v-else-if="obj.youtube"
                                      ><v-icon small style="color:#FF0000 !important;">mdi-youtube</v-icon> @{{obj.handle}}</a>
                                      <a
                                        v-else
                                      ><v-icon small style="color:#E1306C !important;">mdi-instagram</v-icon> @{{obj.handle}}</a>
                                    </v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                              <v-tooltip v-if="!item.isLoading && item.influencerID && item.isPlatformConnected !== false" bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon @click="true" color="green" v-on="on">done</v-icon>
                                </template>
                                <span>Registered on IMS</span>
                              </v-tooltip>
                              <v-tooltip v-if="!item.isLoading && item.influencerID && item.isPlatformConnected === false" bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon @click="true" color="red" v-on="on">cancel</v-icon>
                                </template>
                                <span>Platform handle disconnected</span>
                              </v-tooltip>
                              <v-tooltip v-if=" !item.isLoading && !item.influencerID" bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon @click="true" color="red" v-on="on">cancel</v-icon>
                                </template>
                                <span>Not in IMS</span>
                              </v-tooltip>
                              <p class="text-danger mb-0" v-if="item.socialDataErrMessage">({{item.socialDataErrMessage}})</p>
                              <p class="caption caption-text ma-0" style="font-size:12px;" v-if="checkReportDate(item.lastReportDate)">(Last date is over 6 months. Please refresh data)</p>
                            </td>
                            <td align="center" style="min-width:200px" @click="openEditItem(item.pairingID, 'platformName')" v-if="item.platformNameEdit === false && displayFields('platformName')">
                              <p>{{ item.platformName | platformDisplayName }}</p>
                              <v-btn
                                icon
                                small
                                color="secondary"
                                title="Edit Platform"
                                @click="changePairingColEdit('platformNameEdit', item, true)"
                                v-if="!item.platformNameEdit && item.platform === 'others'"
                              >
                                <v-icon small>mdi-pencil</v-icon>
                              </v-btn>
                            </td>
                            <td align="center" class="editing" v-if="item.platformNameEdit === true">
                              <v-text-field
                                class="ma-3"
                                hide-details
                                v-model="item.platformName"
                                dense
                                outlined
                                style="width:100%"
                              ></v-text-field>
                              <v-btn color="secondary" style="margin-top:7px;" x-small @click="updatePairingCol(item, 'platformName')">
                                <v-icon class="cursor-pointer" title="Close" x-small>check</v-icon>
                              </v-btn>
                              <v-btn color="error" style="margin-top:7px;" x-small @click="changePairingColEdit('platformNameEdit', item, false)">
                                <v-icon class="cursor-pointer" title="Close" x-small>close</v-icon>
                              </v-btn>
                            </td>
                            <td align="center" style="min-width:200px" @click="openEditItem(item.pairingID, 'remark')" v-if="item.remarkEdit === false && displayFields('remark')">
                              <!-- <p v-html="item.remarks"></p> -->
                              <v-tooltip bottom max-width="300px">
                                <template v-slot:activator="{ on }">
                                  <div v-on="on">
                                    <p class="remark-text">{{item.remarks || '-'}}</p>
                                  </div>
                                </template>
                                <span v-html="renderRemark(item.remarks)"></span>
                              </v-tooltip>
                            </td>
                            <td align="center" class="editing" v-if="item.remarkEdit === true">
                              <v-textarea
                                class="ma-3"
                                hide-details
                                v-model="item.remarks"
                                dense
                                outlined
                                style="width:100%"
                              ></v-textarea>
                            </td>
                            <td align="center" style="min-width:200px" @click="openEditItem(item.pairingID, 'contentFeature')" v-if="item.contentFeatureEdit === false && displayFields('contentFeature')">
                              <!-- <p v-html="item.remarks"></p> -->
                              <v-tooltip bottom max-width="300px">
                                <template v-slot:activator="{ on }">
                                  <div v-on="on">
                                    <p class="remark-text">{{item.contentFeature || '-'}}</p>
                                  </div>
                                </template>
                                <span v-html="renderRemark(item.contentFeature)"></span>
                              </v-tooltip>
                            </td>
                            <td align="center" class="editing" v-if="item.contentFeatureEdit === true">
                              <v-textarea
                                class="ma-3"
                                hide-details
                                v-model="item.contentFeature"
                                dense
                                outlined
                                style="width:100%"
                              ></v-textarea>
                            </td>
                            <td align="center" v-if="displayFields('gender')">
                              <div class="d-flex flex-row pa-2" v-if="item.genderEdit">
                                <v-select
                                  style="min-width:100px;max-width:100px;"
                                  :items="genders"
                                  v-model="item.gender"
                                  dense
                                  hide-details
                                ></v-select>
                                <v-btn color="secondary" style="margin-top:7px;" x-small @click="updatePairingCol(item, 'gender')">
                                  <v-icon class="cursor-pointer" title="Close" x-small>check</v-icon>
                                </v-btn>
                                <v-btn color="error" style="margin-top:7px;" x-small @click="changePairingColEdit('genderEdit', item, false)">
                                  <v-icon class="cursor-pointer" title="Close" x-small>close</v-icon>
                                </v-btn>
                              </div>
                              <div v-if="!item.genderEdit">
                                <v-chip
                                  class="ma-2"
                                  color="#ffffff"
                                  x-small
                                  text-color="black"
                                  style="text-transform: capitalize;"
                                  v-if="!item.genderEdit"
                                >{{item.gender || '-'}}</v-chip>
                                <v-btn
                                  icon
                                  small
                                  color="secondary"
                                  title="Edit Gender"
                                  @click="changePairingColEdit('genderEdit', item, true)"
                                  v-if="!item.genderEdit"
                                >
                                  <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                              </div>
                            </td>
                            <td align="center" v-if="displayFields('ageGroup')">
                              <div class="d-flex flex-row pa-2" v-if="item.ageGroupEdit">
                                <v-select
                                  style="min-width:100px;max-width:100px;"
                                  :items="ageGroups"
                                  v-model="item.age_group"
                                  dense
                                  hide-details
                                ></v-select>
                                <v-btn color="secondary" style="margin-top:7px;" x-small @click="updatePairingCol(item, 'age_group')">
                                  <v-icon class="cursor-pointer" title="Close" x-small>check</v-icon>
                                </v-btn>
                                <v-btn color="error" style="margin-top:7px;" x-small @click="changePairingColEdit('ageGroupEdit', item, false)">
                                  <v-icon class="cursor-pointer" title="Close" x-small>close</v-icon>
                                </v-btn>
                              </div>
                              <div v-if="!item.ageGroupEdit">
                                <v-chip
                                  class="ma-2"
                                  color="#ffffff"
                                  x-small
                                  text-color="black"
                                  style="text-transform: capitalize;"
                                >{{item.age_group || '-'}}</v-chip>
                                <v-btn
                                  icon
                                  small
                                  color="secondary"
                                  title="Edit Age Group"
                                  @click="changePairingColEdit('ageGroupEdit', item, true)"
                                  v-if="!item.ageGroupEdit"
                                >
                                  <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                              </div>
                            </td>
                            <td align="center" v-if="displayFields('audAgeGroup')">
                              <div>
                                <div class="d-flex flex-row" v-if="item.audAgesEdit">
                                  <v-select
                                    style="min-width:120px;max-width:320px"
                                    :items="ageGroups"
                                    item-text="code"
                                    item-value="code"
                                    v-model="item.topAudAges"
                                    hide-details
                                    dense
                                    multiple
                                    @change="checkSelectLimit(item, 'topAudAges')"
                                  ></v-select>
                                  <v-btn color="secondary" style="margin-top:7px;" x-small @click="updatePairingCol(item, 'topAudAges')">
                                    <v-icon class="cursor-pointer" title="Close" x-small>check</v-icon>
                                  </v-btn>
                                  <v-btn color="error" style="margin-top:7px;" x-small @click="changePairingColEdit('audAgesEdit', item, false)">
                                    <v-icon class="cursor-pointer" title="Close" x-small>close</v-icon>
                                  </v-btn>
                                </div>
                                <v-chip
                                  class="ma-2"
                                  v-if="(!item.audAges || (Array.isArray(item.audAges) && item.audAges.length === 0))  && (!item.topAudAges || (Array.isArray(item.topAudAges) && item.topAudAges.length === 0))"
                                  color="#ffffff"
                                  x-small
                                  text-color="black"
                                  style="text-transform: capitalize;"
                                >{{'-'}}</v-chip>
                                <div v-if="Array.isArray(item.audAges) && Array.isArray(item.topAudAges)">
                                  <v-menu
                                    v-if="(item.audAges.length || item.topAudAges.length) && !item.audAgesEdit"
                                    :close-on-content-click="false"
                                    top                                                 
                                    offset-x                              
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        class="multi-select-more-btn ma-2"
                                        :id="'btnMore_'+parentIndex"
                                        v-show="(item.audAges.length || item.topAudAges.length) && !item.audAgesEdit"  
                                        x-small
                                        v-bind="attrs"
                                        v-on="on"
                                        text
                                       color="secondary">
                                        <span v-if="item.topAudAges && item.topAudAges.length">
                                          {{item.topAudAges ? item.topAudAges[0] : '-'}}
                                        </span>
                                        <span v-else>
                                          {{item.audAges.length ? item.audAges[0].code : '-'}}
                                        </span>
                                      </v-btn>
                                    </template>
                                    <v-card max-width="300" style="text-align: left;">
                                      <v-card-text>
                                        <div>Aud. Age Group (Majority)</div>
                                        <div v-if="item.audAgesDisplay">
                                          <v-divider></v-divider>
                                          <div
                                          class="d-flex justify-space-between"
                                          v-for="(audAge, index) in item.audAgesDisplay"
                                          :key="index">                                    
                                            <v-chip
                                              class="ma-2"
                                              x-small
                                            >{{audAge.code}}</v-chip>
                                            <span class="more-percent" v-if="audAge.weight">({{(audAge.weight * 100).toFixed(2)}}%)</span>
                                          </div>
                                        </div>
                                        <v-divider></v-divider>
                                        <div
                                        class="d-flex justify-space-between"
                                        v-for="(age, index) in item.audAges"
                                        :key="index">                                    
                                          <v-chip
                                            class="ma-2"
                                            x-small           
                                          >{{age.code}}</v-chip>
                                          <span class="more-percent">({{(age.weight * 100).toFixed(2)}}%)</span>
                                        </div>
                                      </v-card-text>
                                    </v-card>
                                  </v-menu>
                                </div>
                                <div v-if="!item.audAgesEdit">
                                  <!-- <v-chip               
                                    class="ma-2"
                                    x-small             
                                  >{{item.topAudAges ? item.topAudAges[0] : '-'}}</v-chip> -->
                                  <v-btn
                                    icon
                                    small
                                    color="secondary"
                                    title="Edit Aud. Age Group"
                                    @click="changePairingColEdit('audAgesEdit', item, true)"
                                    v-if="!item.audAgesEdit"
                                  >
                                    <v-icon small>mdi-pencil</v-icon>
                                  </v-btn>
                                </div>
                              </div>
                            </td>
                            <td align="center" v-if="displayFields('country')">
                              <!-- <v-chip
                                class="ma-2"
                                color="#ffffff"
                                x-small
                                text-color="black"
                                style="text-transform: capitalize;"
                              >{{item.country || '-'}}</v-chip> -->
                              <div class="d-flex flex-row" v-if="item.audCountryEdit">
                                <v-select
                                  style="min-width:120px;max-width:320px"
                                  :items="locationItems"
                                  item-text="name"
                                  item-value="name"
                                  v-model="item.topCountries"
                                  hide-details
                                  dense
                                  multiple
                                  @change="checkSelectLimit(item, 'topCountries')"
                                ></v-select>
                                <v-btn color="secondary" style="margin-top:7px;" x-small @click="updatePairingCol(item, 'topCountries')">
                                  <v-icon class="cursor-pointer" title="Close" x-small>check</v-icon>
                                </v-btn>
                                <v-btn color="error" style="margin-top:7px;" x-small @click="changePairingColEdit('audCountryEdit', item, false)">
                                  <v-icon class="cursor-pointer" title="Close" x-small>close</v-icon>
                                </v-btn>
                              </div>
                              <v-chip
                                class="ma-2"
                                v-if="(!item.countries || (Array.isArray(item.countries) && item.countries.length === 0)) && (!item.topCountries || (Array.isArray(item.topCountries) && item.topCountries.length === 0))"
                                color="#ffffff"
                                x-small
                                text-color="black"
                                style="text-transform: capitalize;"
                              >{{'-'}}</v-chip>
                              <div v-if="Array.isArray(item.countries) && Array.isArray(item.topCountries)">
                                <v-menu
                                  v-show="(item.countries.length || item.topCountries.length) && !item.audCountryEdit"
                                  :close-on-content-click="false"
                                  top                                                 
                                  offset-x                              
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="multi-select-more-btn ma-2"
                                      :id="'btnMore_'+parentIndex"        
                                      v-show="(item.countries.length || item.topCountries.length) && !item.audCountryEdit"   
                                      x-small
                                      v-bind="attrs"
                                      v-on="on"
                                      text
                                     color="secondary">
                                      <span v-if="item.topCountries && item.topCountries.length">
                                        {{item.topCountries ? item.topCountries[0] : '-'}}
                                      </span>
                                      <span v-else>
                                        {{item.countries.length ? item.countries[0].name : '-'}}
                                      </span>
                                    </v-btn>
                                  </template>
                                  <v-card max-width="300" style="text-align: left;">
                                    <v-card-text>
                                      <div>Aud. Country (Majority)</div>
                                      <div v-if="item.topCountryDisplay">
                                        <v-divider></v-divider>
                                        <div
                                        class="d-flex justify-space-between"
                                        v-for="(country, index) in item.topCountryDisplay"
                                        :key="index">                                    
                                          <v-chip
                                            class="ma-2"
                                            x-small           
                                          >{{country.name}}</v-chip>
                                          <span class="more-percent" v-if="country.weight">({{(country.weight * 100).toFixed(2)}}%)</span>
                                        </div>
                                      </div>
                                      <v-divider></v-divider>
                                      <div
                                      class="d-flex justify-space-between"
                                      v-for="(country, index) in item.countries"
                                      :key="index">                                    
                                        <v-chip
                                          class="ma-2"
                                          x-small           
                                        >{{country.name}}</v-chip>
                                        <span class="more-percent" v-if="country.weight">({{(country.weight * 100).toFixed(2)}}%)</span>
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                </v-menu>
                              </div>
                              <div v-if="!item.audCountryEdit">
                                <!-- <v-chip               
                                  class="ma-2"
                                  x-small             
                                >{{item.topCountries ? item.topCountries[0] : '-'}}</v-chip> -->
                                <v-btn
                                  icon
                                  small
                                  color="secondary"
                                  title="Edit Aud. Country"
                                  @click="changePairingColEdit('audCountryEdit', item, true)"
                                  v-if="!item.audCountryEdit"
                                >
                                  <v-icon small>mdi-pencil</v-icon>
                                </v-btn>                   
                              </div>
                            </td>
                            <td align="center" v-if="displayFields('followers')">
                              <div class="d-flex flex-row pa-2" v-if="item.followersEdit">
                                <v-text-field
                                  class="ma-3"
                                  type="number"
                                  hide-details
                                  v-model="item.followers"
                                  dense
                                  outlined
                                  style="width:100%;min-width:150px"
                                ></v-text-field>
                                <div class="d-flex flex-row mt-2">
                                  <v-btn color="secondary" style="margin-top:7px;" x-small @click="updatePairingCol(item, 'followers')">
                                    <v-icon class="cursor-pointer" title="Close" x-small>check</v-icon>
                                  </v-btn>
                                  <v-btn color="error" style="margin-top:7px;" x-small @click="changePairingColEdit('followersEdit', item, false)">
                                    <v-icon class="cursor-pointer" title="Close" x-small>close</v-icon>
                                  </v-btn>
                                </div>
                              </div>
                              <div v-if="!item.followersEdit">
                                <v-chip
                                  class="ma-2"
                                  color="#CFD8DC"
                                  x-small
                                  text-color="black"
                                >{{item.followers ? formatNumber(item.followers) : '-'}}</v-chip>
                                <v-btn
                                  icon
                                  small
                                  color="secondary"
                                  title="Edit Followers"
                                  @click="changePairingColEdit('followersEdit', item, true)"
                                  v-if="!item.followersEdit && item.platform === 'others'"
                                >
                                  <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                              </div>
                            </td>
                            <td align="center" v-if="displayFields('genderPercentage')">
                              <div style="width:75px;">
                                <PieChart
                                  :name="`genderPie${parentIndex}`"
                                  :title="genderPie.title"
                                  :labels="genderPie.labels"
                                  :backgroundColors="genderPie.backgroundColors"
                                  :items="item.audience_genders"
                                  :options="genderPie.options"
                                  :width="genderPie.width"
                                  :height="genderPie.height"
                                  v-if="item.audience_genders && item.audience_genders.length > 0 && showPie"
                                />
                              </div>
                            </td>
                            <td align="center" v-if="displayFields('audienceCred')">
                              <v-chip
                                class="ma-2"
                                x-small
                                :color="item.audience_credibility_color"
                                text-color="white"
                              >{{item.audience_credibility}}%</v-chip>
                              <span class="text-danger" v-if="item.message">({{item.message}})</span>
                            </td>
                            <td align="center" v-if="displayFields('avgLikes')">
                              <v-chip
                                class="ma-2"
                                color="#CFD8DC"
                                x-small
                                text-color="black"
                              >{{item.avg_likes ? formatNumber(item.avg_likes) : '-'}}</v-chip>
                            </td>
                            <td align="center" v-if="displayFields('avgComments')">
                              <v-chip
                                class="ma-2"
                                color="#CFD8DC"
                                x-small
                                text-color="black"
                              >{{item.avg_comments ? formatNumber(item.avg_comments) : '-'}}</v-chip>
                            </td>
                            <td align="center" v-if="displayFields('avgReelsPlays')">
                              <v-chip
                                class="ma-2"
                                color="#CFD8DC"
                                x-small
                                text-color="black"
                              >{{item.avg_reels_plays ? formatNumber(item.avg_reels_plays) : '-'}}</v-chip>
                            </td>
                            <td align="center" v-if="displayFields('avgViews')">
                              <v-chip
                                class="ma-2"
                                color="#CFD8DC"
                                x-small
                                text-color="black"
                              >{{item.avg_views ? formatNumber(item.avg_views) : '-'}}</v-chip>
                            </td>
                            <td align="center" v-if="displayFields('avgSaves')">
                              <v-chip
                                class="ma-2"
                                color="#CFD8DC"
                                x-small
                                text-color="black"
                              >{{item.avg_saves ? formatNumber(item.avg_saves) : '-'}}</v-chip>
                            </td>
                            <td align="center" v-if="displayFields('avgShares')">
                              <v-chip
                                class="ma-2"
                                color="#CFD8DC"
                                x-small
                                text-color="black"
                              >{{item.avg_shares ? formatNumber(item.avg_shares) : '-'}}</v-chip>
                            </td>
                            <td align="center" v-if="displayFields('medianEngagementRate')">
                              <v-chip
                                class="ma-2"
                                color="#CFD8DC"
                                x-small
                                text-color="black"
                              >{{item.median_engagement_rate ? `${item.median_engagement_rate}%` : '-'}}</v-chip>
                            </td>
                            <td align="center" v-if="displayFields('infInterests')">
                              <v-chip
                                v-if="!item.infInterests || item.infInterests.length === 0"
                                class="ma-2"
                                color="#ffffff"
                                x-small
                                text-color="black"
                                style="text-transform: capitalize;"
                              >{{'-'}}</v-chip>
                              <v-chip                                 
                                v-else                              
                                v-for="(interest, index) in item.infInterests"
                                :key="index"
                                v-show="index === 0"
                                class="ma-2"
                                x-small             
                              >{{interest.name}}</v-chip>                              
                              
                              <v-menu                                                            
                              v-show="item.infInterests"      
                              :close-on-content-click="false"    
                              top                                                 
                              offset-x                              
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    :id="'btnMore_'+item.id"
                                    v-show="item.infInterests && item.infInterests.length > 0"
                                    color="secondary"
                                    x-small
                                    v-bind="attrs"
                                    v-on="on"
                                    text
                                  >
                                    More...
                                  </v-btn>
                                </template>
                                <v-card max-width="300" style="text-align: left;">
                                  <v-card-text>
                                    <div>Influencer Interests</div>
                                    <v-divider></v-divider>                                    
                                    <v-chip                                      
                                      v-for="(interest, index) in item.infInterests"
                                      :key="index"
                                      v-show="index !== 0"
                                      class="ma-2"
                                      small           
                                    >{{interest.name}}</v-chip>
                                  </v-card-text>
                                </v-card>
                              </v-menu>
                            </td>
                            <td align="center" v-if="displayFields('interests')">
                              <v-chip
                                v-if="!item.audience_interests || item.audience_interests.length === 0"
                                class="ma-2"
                                color="#ffffff"
                                x-small
                                text-color="black"
                                style="text-transform: capitalize;"
                              >{{'-'}}</v-chip>
                              <v-chip                                 
                                v-else                              
                                v-for="(interest, index) in item.audience_interests"
                                :key="index"
                                v-show="index === 0"
                                class="ma-2"
                                x-small             
                              >{{interest.name}}</v-chip>                              
                              
                              <v-menu                                                            
                                v-show="item.audience_interests"
                                :close-on-content-click="false"
                                top
                                offset-x
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      :id="'btnMore_'+parentIndex"
                                      v-show="item.audience_interests && item.audience_interests.length > 0"
                                      color="secondary"
                                      x-small
                                      v-bind="attrs"
                                      v-on="on"
                                      text
                                    >
                                      More...
                                    </v-btn>
                                  </template>
                                  <v-card max-width="300" style="text-align: left;">
                                    <v-card-text>
                                      <div>Audience Interests</div>
                                      <v-divider></v-divider>
                                      <div
                                      class="d-flex justify-space-between"
                                      v-for="(interest, index) in item.audience_interests"
                                      :key="index">                                    
                                        <v-chip
                                          class="ma-2"
                                          x-small           
                                        >{{interest.name}}</v-chip>
                                        <span style="more-percent">({{(interest.weight * 100).toFixed(2)}}%)</span>
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                </v-menu>
                            </td>
                            <td align="center" v-if="displayFields('engagement')">
                              <span v-if="item.engagement_rate && item.engagement_rate !== '0.00'">{{item.engagement_rate}}%</span>
                              <span class="caption" v-else-if="item.engagement_rate === '0.00'">
                                <v-icon small data-toggle="tooltip" data-placement="top" title="Hidden">mdi-eye-off</v-icon>
                              </span>
                              <span v-else>-</span>
                            </td>
                            <td align="center" v-if="displayFields('rateCard')">
                              <!-- <v-chip
                                v-if="!item.isLoading && !item.influencerID"
                                class="ma-2"
                                color="#ffffff"
                                x-small
                                text-color="black"
                                style="text-transform: capitalize;"
                              >{{'-'}}</v-chip>                         -->
                              <v-hover v-slot:default="{ hover }">
                                <v-chip
                                  v-if="item.rateCard"
                                  class="ma-2"
                                  color="primary"
                                  x-small
                                  text-color="white"
                                  :elevation="hover ? 12 : 2"
                                  :class="{ 'on-hover': hover }"
                                  @click="openRateCardView(item.rateCard)"
                                >
                                  View Details
                                </v-chip>
                              </v-hover>
                              <div v-if="item.rateCard" style="font-size:13px">
                                ({{formatUploadedDate(item.rateCard.createdAt)}})
                              </div>
                              <!-- <v-menu
                              v-if="!item.isLoading"
                              max-height="500px"
                              :close-on-content-click="false"
                              top
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    :id="'btnRateCard_'+parentIndex"
                                    color="secondary"
                                    x-small
                                    v-bind="attrs"
                                    v-on="on"
                                    text
                                    @click="getRateCard(item)"
                                  >
                                   View
                                  </v-btn>
                                </template>
                                <v-card max-width="350" style="text-align: left;width:300px;">
                                  <v-card-text>
                                    <v-expansion-panels v-model="openExpansion" multiple>
                                      <v-expansion-panel>
                                        <v-expansion-panel-header>
                                          <div>IMS Imported Rates <br><span style="font-size:10px;">(in SGD per item)</span></div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <rate-card-preview
                                            :data="inputRates"
                                            type="IMS"
                                          />
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <v-expansion-panel>
                                        <v-expansion-panel-header>
                                          <div>Rate Card Form Rates <br><span style="font-size:10px;">(in SGD per item)</span></div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <rate-card-preview
                                            :data="rateCardFormRates"
                                            type="rateCard"
                                          />
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                    </v-expansion-panels>
                                  </v-card-text>
                                </v-card>
                              </v-menu> -->
                            </td>
                            <!-- Elimination Status stays scrollable and sits before the frozen block. -->
                            <td align="center" v-if="displayFields('eliminationStatus')">
                              <v-chip
                                v-if="item.eliminationStatus===eliminationStatus.NEW"
                                class="ma-2"
                                color="primary"
                                x-small
                                text-color="white"
                              >
                                New
                                <v-icon right x-small>new_releases</v-icon>
                              </v-chip>
                              <v-tooltip bottom v-if="item.eliminationStatus===eliminationStatus.PENDING">
                                <template v-slot:activator="{ on }">
                                  <v-chip class="ma-2" color="primary" v-on="on" x-small text-color="white">
                                    Pending Client
                                    <v-icon right x-small>loop</v-icon>
                                  </v-chip>
                                </template>
                                <span>Pending Client's Response</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="item.eliminationStatus===eliminationStatus.SELECTED">
                                <template v-slot:activator="{ on }">
                                  <v-chip class="ma-2" color="#8BC34A" v-on="on" x-small text-color="white">
                                    Selected
                                    <v-icon right x-small>mdi-check</v-icon>
                                  </v-chip>
                                </template>
                                <span>Client selected this influencer</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="item.eliminationStatus===eliminationStatus.ELIMINATED">
                                <template v-slot:activator="{ on }">
                                  <v-chip
                                    @click="showReason(item.eliminationReason)"
                                    class="ma-2"
                                    color="red"
                                    x-small
                                    v-on="on"
                                    text-color="white"
                                  >
                                    Eliminated
                                    <v-icon x-small>mdi-close</v-icon>
                                  </v-chip>
                                </template>
                                <span>Click to view the reason</span>
                              </v-tooltip>
                              <v-chip
                                v-if="!item.success && !item.isLoading"
                                class="ma-2"
                                color="red"
                                x-small
                                text-color="white"
                              >Fail</v-chip>
                            </td>
                            <td align="center" class="pairing-freeze-deliverables" v-if="showFrozenPairingColumns && displayFields('AIPayout')">
                              <p class="deliverable-txt mb-0">
                                {{formatPairingDeliverables(campaignHelper.getDeliverableDetails(item.deliverableDetails))}}
                              </p>
                              <v-icon
                              small
                              color="secondary"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Edit"
                              v-if="!disableLockedCOGS"
                              @click="priceMultiplierHandler(item)">edit</v-icon>
                            </td>
                            <td
                              align="center"
                              style="cursor: pointer"
                              class="pairing-freeze-payout"
                              v-if="showFrozenPairingColumns && item.payoutEdit === false && displayFields('payout')"
                            >
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <div v-on="on">
                                    {{utilsFunc.currencySym(item.currency)}}
                                    {{item.payoutAmount  | thousandSeprator}}
                                    <v-icon small color="secondary" data-toggle="tooltip" data-placement="top" title="GST enabled" v-if="item.isGST">mdi-alert-circle-outline</v-icon>
                                    <!-- locked COGS button -->
                                    <v-icon
                                    small
                                    color="secondary"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Locked COGS"
                                    v-if="!isAdmin && disableLockedCOGS"
                                    @click="openLockedCOGSDialog(campaign)">mdi-lock</v-icon>
                                    <!-- locked button -->
                                    <!-- <v-btn
                                      class="ml-1"
                                      small
                                      color="secondary"
                                      @click="changeLock(campaign, false)"
                                      v-else-if="isAdmin && disableLockedCOGS"
                                    >
                                      <v-icon small>mdi-lock-open</v-icon> Unlock
                                    </v-btn> -->
                                    <!-- payout edit button -->
                                    <v-icon
                                    small
                                    color="secondary"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Pending Payouts"
                                    v-else-if="item.payoutStatus == payoutStatus.CONFIRMED && isPendingActivity(item)"
                                    @click="openLockedPayoutEditDialog(item)">mdi-clock-alert-outline</v-icon>
                                    <v-icon
                                    small
                                    color="secondary"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Locked"
                                    v-else-if="item.payoutStatus == payoutStatus.CONFIRMED && !isPendingActivity(item)"
                                    @click="openLockedPayoutEditDialog(item)">mdi-lock</v-icon>
                                    <!-- edit button -->
                                    <v-icon
                                    small
                                    color="secondary"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Edit"
                                    v-else
                                    @click="openPayoutEditDialog(item)">edit</v-icon>
                                  </div>
                                </template>
                                <span>{{displayGSTText(item)}}</span><br>
                                <span v-if="item.sgdAmt">Estimated SGD: {{item.sgdAmt}}</span>
                              </v-tooltip>
                            </td>
                            <td
                              align="center"
                              style="cursor: pointer"
                              class="pairing-freeze-payout"
                              v-if="showFrozenPairingColumns && item.payoutEdit === true  && displayFields('payout')"
                            >
                              <v-text-field
                                class="mt-3"
                                style="width:100px;"
                                dense
                                outlined
                                v-model="item.payoutAmount"
                              ></v-text-field>
                            </td>
                            <!-- Pairing Status -->
                            <td align="center" class="pairing-freeze-pairing" v-if="showFrozenPairingColumns && item.statusEdit === false && displayFields('pairingStatus')" @click="openEditItem(item.pairingID, 'status')">
                              <v-chip class="ma-2" outlined x-small>
                                {{getPairingStatusLabels(item.pairingStatus)}}
                                <v-icon v-if="item.payoutStatus == payoutStatus.CONFIRMED" right x-small>mdi-lock</v-icon>
                                <v-icon v-else right x-small>mdi-circle-edit-outline</v-icon>
                              </v-chip>
                            </td>
                            <td align="center" class="pairing-freeze-pairing" v-if="showFrozenPairingColumns && item.statusEdit === true">
                              <v-select
                                v-model="item.pairingStatus"
                                :items="acceptPairingStatusOptions"
                                item-value="status"
                                item-text="display"
                                label="Pairing Status"
                                @change="changePairingStatus(item)"
                              ></v-select>
                            </td>
                            <!-- actions -->
                            <!-- <td align="center">
                              <v-progress-circular
                                v-if="item.isLoading"
                                :width="2"
                                color="green"
                                indeterminate
                              ></v-progress-circular>
                              <v-menu
                                bottom
                                left
                                v-if="!item.isLoading"
                                offset-y
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn color="secondary" small v-on="on" v-bind="attrs">Actions</v-btn>
                                </template>

                                <v-list>
                                  <v-list-item
                                    v-for="(action, i) in actions"
                                    :key="i"
                                    @click="executeMethod(action.method, item)"
                                  >
                                    <v-list-item-icon style="margin-right:0px;">
                                      <v-icon :color="action.color" v-text="action.icon" small ></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title style="text-align: center;">{{ action.name }}</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </td> -->
                          </tr>
                        </draggable>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-layout>
              <loading
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="true"
                loader="bars"
                background-color="#000"
                color="secondary"
                width.number="90"
                height.number="90"
              />
            </v-container>
          </div>
          <v-card-actions class="ims-modal-actions pairing-modal-actions">
            <v-btn-toggle
              v-model="optionVal"
              mandatory
              color="secondary"
              @change="getPairedInfluencers(campaign.id)"
            >
              <v-btn class="option-btn" :class="{ 'secondary': optionVal === 0 }">Option A</v-btn>
              <v-btn class="option-btn" :class="{ 'secondary': optionVal === 1 }">Option B</v-btn>
            </v-btn-toggle>
            <v-spacer></v-spacer>
            <v-btn v-if="showBtnCO" color="secondary" @click="invokeSendToAM()">Send to AM</v-btn>
            <v-btn color="secondary" @click="showPairingEliminEditModal()">Send To Client</v-btn>
            <v-btn color="secondary" target="_blank" :to="'/campaigns/'+ campaign.id +'/invite-influencer'">Send Invitation</v-btn>
            <v-btn color="secondary" target="_blank" :to="'/influencers/invoices-brief-confirmation?id=' + campaign.id">Invoices & Brief Confirmation</v-btn>
            <v-btn color="secondary" target="_blank" :to="'/finance/payment-consolidation/status?id=' + campaign.id">Payment Consolidation Status</v-btn>
            <v-btn color="secondary" text @click="close()">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <influencer-list-modal
      v-model="showInfluencerSearchResult"
      :value1="showInfluencerSearchResult"
      :result="influencerSearchResult"
      :influencers="selected"
      :keyword="currentKeywordSearch"
      @input1="input1"
      @select="select"
    ></influencer-list-modal>
    <!-- Reason dialog -->
    <v-dialog v-model="reasonDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Reason for elimination</v-card-title>
        <v-card-text>{{eliminationReason}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="reasonDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Reason dialog -->
    <k-toast :variant="toast.variant" :header="toast.header" :content="toast.content"></k-toast>
    <settings-for-ai-modal
      v-model="settingAIDialog"
      :value="settingAIDialog"
      @paramsUpdated="paramsUpdated()"
    />
    <!-- Update pairing dialog -->
    <settings-for-pairing
      v-model="updatePairingDialog"
      :value="updatePairingDialog"
      :view-only="viewOnly"
      :data="activePairingData"
      @pairChanged="pairChanged()"
    />
    <!-- Update pairing dialog -->
    <!-- Price1 Price2 Multiplier Dialog -->
    <price-multiplier-modal
      v-model="priceMultiplierDialog"
      :value="priceMultiplierDialog"
      :pairedInfluencer="priceMultiplierInfluencerData"
      :campaignData="campaign"
      :multiple="isMultipleDeliverables"
      :multipleInfs="actionSelected"
      @clearSelected="clearActionSelected()"
      @savedFromPriceMultplier="pairChanged()"
    />
    <!-- Price1 Price2 Multiplier Dialog -->
    <!-- Full Screen Progress Loading Dialog -->
    <full-screen-progress
    :show="bulkProgress.show"
    isStatus="true"
    :processing="bulkProgress.processing"
    :complete="bulkProgress.complete"
    :color="secondary" />
    <!-- Full Screen Progress Loading Dialog -->
    <!-- get approval dialog -->
      <!-- <get-approval-modal
        v-model="getApprovalDialog"
        :value="getApprovalDialog"
        :pairing="approvalPairing"
        @saved="savedGetApproval"
      /> -->
    <!-- end of get approval dialog -->
    
    <!-- req cogs approval modal -->
      <req-cogs-approval-modal
        v-model="reqApprovalDialog"
        :value="reqApprovalDialog"
        :pairing="payoutEditPairing"
        :amount="reqAmt"
        :reasons="reqReasons"
        :budget="budget"
        :currentCOGS="measurement.budget"
        :cogsPercent="measurement.cogsPercentage"
        @saved="getPairedInfluencers(campaign.id)"
      />
    <!-- end of req cogs approval modal -->

    <!-- payout update table -->
      <payout-update-modal 
        v-model="editPayoutDialog"
        :value="editPayoutDialog"
        :pairing="payoutEditPairing"
        :lockedPayout="lockedPayout"
        :cappedCOGS="budget"
        :currentCOGS="measurement.budget"
        :campaign="campaign"
        @budgetExceeded="openReqApprovalDialog"
        @refreshPairing="getPairedInfluencers(campaign.id)"
      />
    <!-- end of payout update table -->
    
    <!-- pairing elimiation edit modal -->
    <pairing-elimination-edit-modal
    v-model="eliminationDialog"
    :campaingData="campaingDataForElimination"
    @invokeSendToClient="invokeSendToClient"/>
    <!-- end of pairing elimionti... -->
  </v-layout>
</template>

<script>
import moment from 'moment';
import campaignAPIs from '../campaignAPIs';
import campaignHelper from '../campaignHelper'
import utils from '../../../../utils';
// import campaignConfig from '../config';
import influencerList from '../../Influencer/InfluencerDataTable.vue';
import pairingInfluencersTable from '../../Pairing/PairingDataTable.vue';
import influencerAPIs from '../../Influencer/influencerAPIs';
import InfluencerListModal from './InfluencerListModal';
// import GetApprovalModal from './GetApprovalModal';
import ReqCogsApprovalModal from './ReqCogsApprovalModal';
import PayoutUpdateModal from './PayoutUpdateModal';
import pairingAPIs from '../../Pairing/pairingAPIs';
import Loading from 'vue-loading-overlay';
import KToast from '../../../scoped/custom/KToast';
import FullScreenProgress from '../../../scoped/custom/FullScreenProgress';
import KInfluencerSearchBox from '../../../scoped/influencer/InfluencerSearchBox';
import RateCardPreview from '../../Influencer/RateCard/Preview.vue';
import 'vue-loading-overlay/dist/vue-loading.css';
import config from '../config';
import globalConfig from '@/config';
import SettingsForAiModal from './SettingsForAIModal';
import SettingsForPairing from './SettingsForPairing';
import PriceMultiplierModal from './PriceMultiplierModal';
import PairingEliminationEditModal from './PairingEliminationEditModal';
import SocialHandle from '../../../scoped/custom/SocialHandle'
import draggable from 'vuedraggable';
import PieChart from '@/components/chartjs/Pie';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';

import { mapGetters, mapState } from 'vuex'

const SearchTypeEnum = Object.freeze({ KEYWORD: 'keyword', HANDLE: 'handle', BULKUPLOAD: 'bulkupload' });
const Steps = Object.freeze({ FIND_INFLUENCERS: 1, REVIEW: 2, ELIMINATION: 3 });
export default {
  name: 'ViewPairingModal',
  props: {
    value: Boolean,
    campaignData: Object,
    client: Object,
    unlockCogs: Boolean
  },
  components: {
    influencerList,
    pairingInfluencersTable,
    Loading,
    InfluencerListModal,
    KInfluencerSearchBox,
    KToast,
    FullScreenProgress,
    SettingsForAiModal,
    SettingsForPairing,
    PriceMultiplierModal,
    PairingEliminationEditModal,
    draggable,
    PieChart,
    SocialHandle,
    RateCardPreview,
    // GetApprovalModal,
    ReqCogsApprovalModal,
    PayoutUpdateModal
  },
  data() {
    return {
      optionVal: 0,
      showFrozenPairingColumns: true,
      toast: {
        variant: '',
        content: '',
        header: ''
      },
      fromAI: {
        // Default setting
        force: false,
        page: 0
      },
      loadingAI: false,
      bulkProgress: {
        loading: true,
        processing: 0,
        complete: 0
      },
      utilsFunc: utils.func,
      showEditDialog: false,
      reasonDialog: false,
      settingAIDialog: false,
      // getApprovalDialog: false,
      lockedPayout: false,
      reqApprovalDialog: false,
      editPayoutDialog: false,
      eliminationDialog: false,
      campaingDataForElimination: {},
      // approvalPairing: {},
      reqApprovalPairing: {},
      payoutEditPairing: {},
      reqAmt: '',
      reqReasons: '',
      eliminationReason: '',
      // pairingStatusDisplay: config.pairingStatusDisplay,
      eliminationStatus: config.eliminationStatus,
      payoutStatus: config.payoutStatus,
      genders: [
        'Male',
        'Female'
      ],
      ageGroups: [
        '18-24',
        '25-34',
        '35-44',
        '13-17',
        '45-64',
        '65-'
      ],
      actions: [
        { name: 'Delete', color: 'red', method: 'delete', icon: 'delete' },
        { name: 'Edit', color: 'secondary', method: 'edit', icon: 'edit' },
        { name: 'View', color: 'secondary', method: 'view', icon: 'mdi-eye' }
      ],
      headers: [
        { text: 'Last Report Date', sortable: true, value: 'lastReportDate', align: 'center', name: 'lastReportDate' },
        {
          text: 'Influencer',
          align: 'center',
          sortable: false,
          value: 'userHandle',
          name: 'influencer'
        },
        { text: 'Platform', sortable: true, value: 'platformName', align: 'center', name: 'platformName' },
        { text: 'Remark', sortable: true, value: 'remarks', align: 'center', name: 'remark' },
        { text: 'Content Feature/pillar', sortable: true, value: 'contentFeature', align: 'center', name: 'contentFeature' },
        { text: 'Gender', sortable: false, value: 'gender', align: 'center', name: 'gender' },
        { text: 'Age Group', sortable: false, value: 'age_group', align: 'center', name: 'ageGroup' },
        { text: 'Aud. Age Group', sortable: false, value: 'aud_age_group', align: 'center', name: 'audAgeGroup' },
        { text: 'Aud. Country', sortable: false, value: 'country', align: 'center', name: 'country' },
        { text: 'Followers', align: 'center', sortable: false, value: 'followers', name: 'followers' },
        { text: 'Follower Gender', sortable: false, value: 'genderPercentage', align: 'center', name: 'genderPercentage' },
        { text: 'Audience Cred.', sortable: false, align: 'center', value: 'audience_credibility', name: 'audienceCred' },
        { text: 'Avg. Likes', sortable: false, align: 'center', value: 'avg_likes', name: 'avgLikes' },
        { text: 'Avg. Comments', sortable: false, align: 'center', value: 'avg_comments', name: 'avgComments' },
        { text: 'Avg. Reels Plays (IG)', sortable: false, align: 'center', value: 'avg_reels_plays', name: 'avgReelsPlays' },
        { text: 'Avg. Views (TT)', sortable: false, align: 'center', value: 'avg_views', name: 'avgViews' },
        { text: 'Avg. Saves (TT)', sortable: false, align: 'center', value: 'avg_saves', name: 'avgSaves' },
        { text: 'Avg. Shares (TT)', sortable: false, align: 'center', value: 'avg_shares', name: 'avgShares' },
        { text: 'Median Engagement Rate', sortable: false, align: 'center', value: 'median_engagement_rate', name: 'medianEngagementRate' },
        { text: 'Influencer interests', sortable: false, align: 'center', value: 'infInterests', name: 'infInterests' },
        { text: 'Audience interests', sortable: false, align: 'center', value: 'audience_interests', name: 'interests' },
        { text: 'Engagement', sortable: false, align: 'center', value: 'engagement_rate', name: 'engagement' },
        { text: 'Rate Card', sortable: false, align: 'center', value: '', name: 'rateCard' },
        { text: 'Elimination Status', sortable: false, align: 'center', value: '', name: 'eliminationStatus' },
        { text: 'Deliverables', sortable: false, align: 'center', value: 'predictedAmount', name: 'AIPayout', class: 'pairing-freeze-deliverables' },
        { text: 'Payout', sortable: false, align: 'center', value: 'payoutAmount', name: 'payout', class: 'pairing-freeze-payout' },
        // { text: 'Labels', sortable: true, align: 'center' },
        { text: 'Pairing Status', sortable: false, align: 'center', value: '', name: 'pairingStatus', class: 'pairing-freeze-pairing' }
        // { text: 'Actions', sortable: false }
      ],
      json_fields: {
        'Handle': {
          callback: item => {
            if (item.platform === 'instagram') {
              return `<a href='http://instagram.com/${item.userHandle}'>${item.userHandle}</a>`
            }
            if (item.platform === 'tiktok') {
              return `<a href='https://www.tiktok.com/@${item.userHandle}'>${item.userHandle}</a>`
            }
            if (item.platform === 'youtube') {
              return `<a href='https://youtube.com/@${item.userHandle}'>${item.userHandle}</a>`
            }
            if (item.platform === 'xiaohongshu') {
              return `<a href='https://xiaohongshu.com/user/profile/${item.xhsID}'>${item.userHandle}</a>`
            }
            if (item.platform === 'facebook') {
              return `<a href='https://facebook.com/@${item.userHandle}'>${item.userHandle}</a>`
            }
            if (item.platform === 'linkedin') {
              return `<a href='https://www.linkedin.com/in/${item.userHandle}'>${item.userHandle}</a>`
            }
            if (item.platform === 'twitter') {
              return `<a href='https://x.com/${item.userHandle}'>${item.userHandle}</a>`
            }
            if (item.platform === 'others') {
              return `<a>${item.userHandle}</a>`
            }
          }
        },
        Platform: 'platform',
        'Custom Platform Name': 'platformName',
        Remark: 'remarks',
        'Content Feature/pillar': 'contentFeature',
        Gender: 'gender',
        'Age Group': 'age_group',
        'Aud. Age Group': 'displayAudAge',
        'Aud. Country': 'displaytopCountry',
        Followers: 'followers',
        'Follower Gender': 'audGenderDisplay',
        'Audience Cred.': 'audience_credibility',
        'Avg. Likes': 'avg_likes',
        'Avg. Comments': 'avg_comments',
        'Avg. Reels Plays (IG)': 'avg_reels_plays',
        'Avg. Views (TT)': 'avg_views',
        'Avg. Saves (TT)': 'avg_saves',
        'Avg. Shares (TT)': 'avg_shares',
        'Median Engagement Rate': 'medianEngRateDisplay',
        'Influencer Interests': 'infInterestDisplay',
        'Aud. Interests': 'audInterestDisplay',
        Engagement: 'engagementRateDisplay',
        'TikTok Posts': 'no_of_tiktok_posts',
        'Posts': 'no_of_posts',
        'Carousels': 'no_of_carousels',
        Videos: 'no_of_video',
        Stories: 'no_of_stories',
        Reels: 'no_of_reels',
        Youtube: 'youtube',
        XHS: 'no_of_xhs_posts',
        Facebook: 'no_of_fb_posts',
        LinkedIn: 'no_of_li_posts',
        X: 'no_of_x_posts',
        'Elimination Status': {
          callback: item => {
            if (item.eliminationStatus === config.eliminationStatus.SELECTED) {
              return 'SELECTED';
            }
            if (item.eliminationStatus === config.eliminationStatus.PENDING) {
              return 'PENDING CLIENT';
            }
            if (item.eliminationStatus === config.eliminationStatus.NEW) {
              return 'NEW';
            }
            return 'ELIMINATED';
          }
        },
        'Pairing Status': {
          field: 'pairingStatus',
          callback: value => {
            let pairingLable
            Object.entries(this.pairingStatus).forEach(item => {
              if (item[1].value === value) {
                pairingLable = item[1].text;
              }
            });
            // if (value === config.pairingStatus.NEW) {
            //   return 'NEW';
            // }
            // if (value === config.pairingStatus.ELIMINATION_PENDING) {
            //   return 'IN ELIMINATION';
            // }
            // if (value === config.pairingStatus.APPROVED) {
            //   return 'APPROVED';
            // }
            // if (value === config.pairingStatus.INVITED) {
            //   return 'INVITED';
            // }
            // if (value === config.pairingStatus.ACCEPT) {
            //   return 'ACCEPTED';
            // }
            // if (value === config.pairingStatus.REJECT) {
            //   return 'REJECTED';
            // }
            return pairingLable
          }
        },
        'Elimination Reason': 'eliminationReason',
        Remarks: 'remarks'
      },
      showHideFields: [
        {
          name: 'influencer',
          label: 'Influencer'
        },
        {
          name: 'lastReportDate',
          label: 'Last Report Date'
        },
        {
          name: 'platformName',
          label: 'Platform Name'
        },
        {
          name: 'remark',
          label: 'Remarks'
        },
        {
          name: 'contentFeature',
          label: 'Content Feature'
        },
        {
          name: 'gender',
          label: 'Gender'
        },
        {
          name: 'ageGroup',
          label: 'Age Group'
        },
        {
          name: 'audAgeGroup',
          label: 'Aud. Age Group'
        },
        {
          name: 'country',
          label: 'Aud. Country'
        },
        {
          name: 'followers',
          label: 'Followers'
        },
        {
          name: 'genderPercentage',
          label: 'Follower Gender'
        },
        {
          name: 'audienceCred',
          label: 'Audience Cred.'
        },
        {
          name: 'avgLikes',
          label: 'Avg. Likes'
        },
        {
          name: 'avgComments',
          label: 'Avg. Comments'
        },
        {
          name: 'avgReelsPlays',
          label: 'Avg. Reels Plays (IG)'
        },
        {
          name: 'avgViews',
          label: 'Avg. Views (TT)'
        },
        {
          name: 'avgSaves',
          label: 'Avg. Saves (TT)'
        },
        {
          name: 'avgShares',
          label: 'Avg. Shares (TT)'
        },
        {
          name: 'medianEngagementRate',
          label: 'Median Engagement Rate'
        },
        {
          name: 'infInterests',
          label: 'Influencer interests'
        },
        {
          name: 'interests',
          label: 'Audience interests'
        },
        {
          name: 'engagement',
          label: 'Engagement'
        },
        {
          name: 'rateCard',
          label: 'Rate Card'
        },
        {
          name: 'AIPayout',
          label: 'Deliverables'
        }
      ],
      defaultPairingDisplayStatus: {
        influencer: true,
        lastReportDate: true,
        platformName: true,
        remark: true,
        contentFeature: true,
        gender: true,
        genderPercentage: true,
        ageGroup: true,
        audAgeGroup: true,
        country: true,
        followers: true,
        audienceCred: true,
        avgLikes: true,
        avgComments: true,
        avgViews: true,
        avgReelsPlays: true,
        medianEngagementRate: true,
        infInterests: true,
        interests: true,
        engagement: true,
        rateCard: true,
        AIPayout: true,
        payout: true,
        eliminationStatus: true,
        pairingStatus: true
      },
      items: [],
      pairedInfluencers: [], // List influencers have been sent to client for elimination
      listReview: [], // For review only
      suggestedInfluencers: [],
      isLoading: false,
      campaign: {},
      searchKeywordAction: '',
      SearchTypeEnum,
      Steps,
      igHandle: '',
      viewOnly: false,
      searchType: SearchTypeEnum.HANDLE,
      actionSelected: [],
      selected: [],
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0
      },
      historySearchResult: null,
      currentKeywordSearch: '', // For intuitive UI
      pairingStepper: Steps.FIND_INFLUENCERS,
      showInfluencerSearchResult: false,
      influencerSearchResult: null,
      activePairingData: null,
      updatePairingDialog: false,
      priceMultiplierDialog: false,
      priceMultiplierInfluencerData: null,
      lineUpItems: [],
      genderItems: ['Male', 'Female'],
      genderPie: {
        title: 'Report Abuse in %',
        labels: ['MALE', 'FEMALE'],
        backgroundColors: ['rgba(66, 165, 244, 1)', 'rgba(239, 83, 80, 1)'],
        options: {
          responsive: true,
          legend: false,
          tooltips: {
            bodyFontSize: 8,
            position: 'average',
            xAlign: 'center',
            yAlign: 'center'
          }
        },
        width: 50,
        height: 50
      },
      searchInfluencerTypes: [
        { text: 'Instagram', value: 'Instagram', icon: 'mdi-instagram', iconColor: '#E1306C' },
        { text: 'TikTok', value: 'TikTok', imgIcon: '/static/img/tiktok-32.png' },
        { text: 'Youtube', value: 'Youtube', icon: 'mdi-youtube', iconColor: '#FF0000' },
        { text: 'Facebook', value: 'Facebook', icon: 'mdi-facebook', iconColor: '#1877F2' },
        { text: 'LinkedIn', value: 'LinkedIn', icon: 'mdi-linkedin', iconColor: '#0A66C2' },
        { text: 'X (Twitter)', value: 'Twitter', imgIcon: '/static/img/x-logo.svg' },
        { text: 'Xiaohongshu', value: 'Xiaohongshu', imgIcon: '/static/img/xhs-black.png' },
        { text: 'Others', value: 'Others', icon: 'mdi-help-circle', iconColor: '#616161' }
      ],
      filteredItems: [],
      ageItems: [],
      locationItems: [],
      searchGender: '',
      searchAge: '',
      searchLocation: '',
      searchPairingStatus: '',
      searchAudCrediblity: '',
      searchInfluencer: 'Instagram',
      platformName: '',
      topFiveAudienceInterests: [],
      disableSaveLineUp: true,
      disableSaveEdit: true,
      isOpen: '',
      openExpansion: [],
      inputRates: {},
      rateCardFormRates: {},
      isPricingDeskEmpty: false,
      isEditing: false,
      searchFilter: '',
      audCrediblityFilters: [
        {name: 'Red', min: 0, max: 30},
        {name: 'Orange', min: 30, max: 50},
        {name: 'Green', min: 50, max: 100}
      ],
      markupCOGSAmount: false,
      campaignHelper,
      oldEditItem: null,
      isMultipleDeliverables: false,
      showPie: true,
      currencyTotals: {},
      disableSort: false,
      searchMethods: [
        { text: 'Search by Handle', value: SearchTypeEnum.HANDLE },
        { text: 'Search by Keyboard', value: SearchTypeEnum.KEYWORD },
        { text: 'Bulk Upload', value: SearchTypeEnum.BULKUPLOAD }
      ]
    };
  },
  watch: {
    campaignData: async function(newCampaignData) {
      this.campaign = newCampaignData;
      this.campaign.pairingDisplayStatus = this.campaign.pairingDisplayStatus || this.defaultPairingDisplayStatus
      // Reset selectedInfluencers
      this.measurement = {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0
      };
      this.toast = {
        content: '',
        header: '',
        variant: ''
      };
      this.clearPairingData()
      await this.$store.dispatch('payment/getCurrencyRates')
      this.getPairedInfluencers(this.campaign.id);
      // this.getSuggestedInfluencerFromAI(this.campaign.id, false);
    },
    items: function(newList) {
      this.calcMeasurements(newList)
    }
  },
  computed: {
    ...mapGetters('pairing', {
      pairingStatus: 'status'
    }),
    ...mapState({
      rateCards: state => state.influencer.rateCards,
      requestedPayoutEdit: state => state.pairing.requestedPayoutEdit,
      campaignUpdated: state => state.campaign.campaignUpdated,
      infDetail: state => state.influencer.infDetail,
      currencyRates: state => state.payment.currencyRates
    }),
    filteredHeaders() {
      return this.headers.filter(h => {
        if (!this.showFrozenPairingColumns && ['AIPayout', 'payout', 'pairingStatus'].includes(h.name)) {
          return false
        }
        let pairingDisplayStatus = this.campaign.pairingDisplayStatus
        if (pairingDisplayStatus !== undefined) {
          if (h.name !== undefined && !pairingDisplayStatus[h.name]) {
            return false
          }
        }
        return true
      })
    },
    selectAllStatus() {
      return utils.func.refreshJSON(this.actionSelected)
    },
    showBtnCO: function() {
      if (Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_LOW) {
        return true;
      } else if (Number(this.$store.state.user.role) === globalConfig.userRoles.AD_STRATEGIST) {
        return true;
      } else {
        return false
      }
    },
    showBtnAM: function() {
      if (Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_LOW) {
        return true;
      } else if (Number(this.$store.state.user.role) === globalConfig.userRoles.ACCOUNT_MANAGER) {
        return true;
      } else {
        return false
      }
    },
    isSuperAdmin: function() {
      return Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_HIGH
    },
    isAdmin: function() {
      return Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_LOW
    },
    pairingStatusOptions: function() {
      // let data = [];
      // Object.entries(config.pairingStatus).forEach(item => {
      //   data.push({
      //     status: item[1],
      //     display: config.pairingStatusDisplay[item[1]]
      //   });
      // });
      // return data;
      let data = [];
      Object.entries(this.pairingStatus).forEach(item => {
        data.push({
          status: item[1].value,
          display: item[1].text
        });
      });
      return data;
    },
    acceptPairingStatusOptions: function() {
      let data = [];
      Object.entries(this.pairingStatus).forEach(item => {
        if (item[1].value === config.pairingStatus.ACCEPTED || item[1].value === config.pairingStatus.NOT_ACCEPTED) {
          data.push({
            status: item[1].value,
            display: item[1].text
          });
        }
      });
      return data;
    },
    filterPairingStatusOptions: function() {
      let data = [{
        status: '',
        display: 'Status (All)'
      },
      {
        status: config.pairingStatus.NEW,
        display: 'Status (New) - ' + this.newPairings
      },
      {
        status: config.pairingStatus.ACCEPTED,
        display: 'Status (Accepted) - ' + this.accepted
      },
      {
        status: config.pairingStatus.NOT_ACCEPTED,
        display: 'Status (Not Accepted) - ' + this.notAccepted
      }
      ];
      // Object.entries(this.pairingStatus).forEach(item => {
      //   if (item[1].value === config.pairingStatus.NEW || item[1].value === config.pairingStatus.ACCEPTED || item[1].value === config.pairingStatus.NOT_ACCEPTED) {
      //     data.push({
      //       status: item[1].value,
      //       display: item[1].text
      //     });
      //   }
      // });
      // data.unshift({
      //   status: '',
      //   display: 'All'
      // });
      return data;
    },
    budget: function() {
      this.markupCOGSAmount = campaignHelper.getMarkupCOGS(this.campaign.ioNumbers, this.client)
      return this.markupCOGSAmount ? this.markupCOGSAmount : Math.floor(this.campaign.budget * 0.26)
    },
    newPairings: function() {
      return this.items.filter(item => item.pairingStatus === this.pairingStatus.NEW.value).length;
    },
    accepted: function() {
      return this.items.filter(item => item.pairingStatus === this.pairingStatus.ACCEPTED.value).length;
    },
    notAccepted: function() {
      return this.items.filter(item => item.pairingStatus === this.pairingStatus.NOT_ACCEPTED.value).length;
    },
    newEliminations: function() {
      return this.items.filter(item => item.eliminationStatus === this.eliminationStatus.NEW).length;
    },
    noOfSelected: function() {
      return this.items.filter(item => item.eliminationStatus === this.eliminationStatus.SELECTED).length;
    },
    noOfEliminated: function() {
      return this.items.filter(item => item.eliminationStatus === this.eliminationStatus.ELIMINATED).length;
    },
    disableLockedCOGS: function() {
      return this.campaign.lockedCOGS || false
    },
    showLockBtn() {
      if (this.campaign.id && !this.campaign.lockedCOGS &&
      (Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_HIGH ||
      Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_LOW ||
      Number(this.$store.state.user.role) === globalConfig.userRoles.AD_STRATEGIST)) {
        return true
      }
      return false
    }
  },
  mounted: async function() {
    if (Object.entries(this.campaign).length !== 0 && this.campaign.constructor !== Object) {
      // only load if the props object isn't empty
      // Refresh list
      this.getPairedInfluencers(this.campaign.id);
    }
    this.getCountries()
    await this.getRateCardLists()
    await this.$store.dispatch('payment/getCurrencyRates')
    this.checkHoverSortIcon()
  },
  methods: {
    formatPairingDeliverables(value) {
      return this.formatDeliverableCounts(value).replace(/X\s*\(Twitter\)\s*Post/g, 'XTP')
    },
    formatDeliverableCounts(value) {
      return String(value || '').replace(/(\d+(?:hrs)?) X /g, '$1 x ')
    },
    getPairingStatusLabels(status) {
      let lable;
      Object.entries(this.pairingStatus).forEach(item => {
        if (item[1].value === status) {
          lable = item[1].text;
        }
      });
      return lable;
    },
    priceMultiplierHandler(item) {
      this.priceMultiplierInfluencerData = item;
      this.isMultipleDeliverables = false;
      this.priceMultiplierDialog = true;
    },
    calculateOutreach(item) {
      const followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels + item.no_of_xhs_posts);
    },
    calculateEngagement(item) {
      const engagements = item.engagements;
      return engagements * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels + item.no_of_xhs_posts);
    },
    calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels + item.no_of_xhs_posts;
    },
    pairChanged() {
      this.updatePairingDialog = false;
      this.priceMultiplierDialog = false;
      this.getPairedInfluencers(this.campaign.id);
    },
    openDeliverableUpdateDialog() {
      this.isMultipleDeliverables = true
      this.priceMultiplierDialog = true;
    },
    updatePairingStatusHandler(pairedInfluencer) {
      this.activePairingData = pairedInfluencer;
      this.updatePairingDialog = true;
      this.viewOnly = false; // For editing
    },
    viewDetailPairing(pairedInfluencer) {
      this.activePairingData = pairedInfluencer;
      this.updatePairingDialog = true;
      this.viewOnly = true; // For view only
    },
    executeMethod(method, data) {
      switch (method) {
        case 'delete':
          this.removeSelectedInfluencer(data.userHandle, data.platform);
          break;
        case 'view':
          this.viewDetailPairing(data);
          break;
        case 'edit':
          this.updatePairingStatusHandler(data);
          break;
        case 'refresh':
          this.refreshPairingData(data);
          break;
      }
    },
    refreshPairingData(data) {
      this.isLoading = true
      this.refreshInfluencerDetail(data.instagramHandle, data.platform.toLowerCase(), data.pairingID);
      this.addToSelectedInfluencers(data.instagramHandle, data.platform.toLowerCase());
    },
    paramsUpdated() {
      this.settingAIDialog = false;
      this.getSuggestedInfluencerFromAI(this.campaign.id, true);
    },
    enableSettingForAI() {
      this.settingAIDialog = !this.settingAIDialog;
    },
    showReason(text) {
      this.eliminationReason = text;
      this.reasonDialog = true;
    },
    editAmount(item) {
      let index = this.items.findIndex(element => element.userHandle === item.userHandle);
      if (index === -1) return; // The item is not present in the list
      this.items[index].isEditting = true;
      this.items.splice();
    },
    // Finish updating payout amount
    // onEnter(item) {
    //   let index = this.items.findIndex(element => element.userHandle === item.userHandle);
    //   if (index === -1) return; // The item is not present in the list
    //   this.items[index].isEditting = false;
    //   this.items.splice();
    //   let payload = {
    //     pairingID: item.pairingID,
    //     payoutAmount: item.payoutAmount
    //   };
    //   pairingAPIs.updatePayoutAmount(payload).then(() => {
    //     if (this.isBudgetOver(this.budget, this.measurement.budget)) {
    //       this.makeToast({
    //         content: 'The current budget for this campaign is exceeded the limited.',
    //         header: 'Warning!',
    //         variant: 'danger'
    //       });
    //     }
    //   });
    // },
    // makeToast(toast) {
    //   this.toast = toast;
    //   this.$bvToast.show('kobe-toast');
    // },
    isSelected(igHandle, platform) {
      return this.selected.find(e => e.handle === igHandle && e.platform === platform);
    },
    async updateLineUp() {
      await this.lineUpItems.map((item, index) => {
        let data = {
          pairingID: item.pairingID,
          lineUpIndex: index
        }
        pairingAPIs.updateLineUpIndex(data)
      })
    },
    invokeSendToAM() {
      if (this.isBudgetOver(this.budget, this.measurement.budget)) {
        if (!this.isSuperAdmin) {
          this.$swal({
            title: 'Are you sure?',
            icon: 'warning',
            confirmButtonText: 'Request for release',
            showCancelButton: true,
            text: `The current budget for this campaign is exceeded the limited. Please check again`
          }).then(result => {
            if (result.value) {
              this.isLoading = true;
              pairingAPIs
              .sendCOGSExceedReminder(this.campaign.id)
              .then(sents => {
                this.isLoading = false;
                this.$swal({
                  title: 'Success',
                  icon: 'info',
                  text: `The request for release has been sent to Admin.`
                });
                this.getPairedInfluencers(this.campaign.id);
              })
              .catch(() => {
                this.isLoading = false;
              });
            }
          })
        }
        if (this.isSuperAdmin) {
          this.$swal({
            title: 'Warning',
            icon: 'warning',
            text: `The current budget for this campaign is exceeded the limited. Please check again`
          }).then(result => {
            if (result.value) {
              this.sendToAM()
            }
          })
        }
        return
      } else {
        this.sendToAM()
      }
    },
    sendToAM() {
      this.$swal({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        text: `${this.newEliminations} new influencer(s) will be sent to AM for approval.`
      }).then(result => {
        if (result.value) {
          this.isLoading = true;
          if (this.lineUpItems.length > 0) {
            this.updateLineUp()
            pairingAPIs
              .sendListInfluencersToAM(this.campaign.id)
              .then(() => {
                this.isLoading = false;
                this.$swal({
                  title: 'Success',
                  icon: 'info',
                  showCancelButton: true,
                  text: `The list has been sent to client.`
                });
                this.getPairedInfluencers(this.campaign.id);
              })
              .catch(() => {
                this.isLoading = false;
              });
          } else {
            pairingAPIs
              .sendListInfluencersToAM(this.campaign.id)
              .then(() => {
                this.isLoading = false;
                this.$swal({
                  title: 'Success',
                  icon: 'info',
                  showCancelButton: true,
                  text: `The list has been sent to AM.`
                });
                this.getPairedInfluencers(this.campaign.id);
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        }
      });
    },
    showPairingEliminEditModal() {
      this.eliminationDialog = true
      this.campaingDataForElimination = Object.assign({}, this.campaign)
    },
    invokeSendToClient() {
      if (this.isBudgetOver(this.budget, this.measurement.budget)) {
        if (!this.isSuperAdmin) {
          this.$swal({
            title: 'Are you sure?',
            icon: 'warning',
            confirmButtonText: 'Request for release',
            showCancelButton: true,
            text: `The current budget for this campaign is exceeded the limited. Please check again`
          }).then(result => {
            if (result.value) {
              this.isLoading = true;
              pairingAPIs
              .sendCOGSExceedReminder(this.campaign.id)
              .then(sents => {
                this.isLoading = false;
                this.$swal({
                  title: 'Success',
                  icon: 'info',
                  text: `The request for release has been sent to Admin.`
                });
                this.getPairedInfluencers(this.campaign.id);
              })
              .catch(() => {
                this.isLoading = false;
              });
            }
          })
        }
        if (this.isSuperAdmin) {
          this.$swal({
            title: 'Warning',
            icon: 'warning',
            text: `The current budget for this campaign is exceeded the limited. Please check again`
          }).then(result => {
            if (result.value) {
              this.sendToClient()
            }
          })
        }
        return;
      } else {
        this.sendToClient()
      }
    },
    sendToClient() {
      this.$swal({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        text: `${this.newEliminations} new influencer(s) will be sent to client for elimination.`
      }).then(result => {
        if (result.value) {
          this.isLoading = true;
          if (this.lineUpItems.length > 0) {
            this.updateLineUp()
            pairingAPIs
              .sendListInfluencersToClient(this.campaign.id)
              .then(sents => {
                this.isLoading = false;
                this.$swal({
                  title: 'Success',
                  icon: 'info',
                  showCancelButton: true,
                  text: `The list has been sent to client.`
                });
                this.getPairedInfluencers(this.campaign.id);
              })
              .catch(() => {
                this.isLoading = false;
              });
          } else {
            pairingAPIs
            .sendListInfluencersToClient(this.campaign.id)
            .then(sents => {
              this.isLoading = false;
              this.$swal({
                title: 'Success',
                icon: 'info',
                showCancelButton: true,
                text: `The list has been sent to client.`
              });
              this.getPairedInfluencers(this.campaign.id);
            })
            .catch(() => {
              this.isLoading = false;
            });
          }
        }
      });
    },
    close() {
      this.$emit('input');
    },
    // For controlling sub modal
    input1() {
      this.showInfluencerSearchResult = false;
    },
    select(userHandle, platform) {
      if (this.selected.find(e => e.handle === userHandle && e.platform === platform.toLowerCase())) {
        // this.removeSelectedInfluencer(userHandle);
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          text: 'Influencer is being selected'
        });
      } else {
        if (platform === 'Instagram') {
          userHandle = userHandle ? utils.func.espaceHandleSign(utils.func.regexMatchIg(userHandle, globalConfig.regexPattern.instagram_profile)) : ''
        } else if (platform === 'TikTok') {
          userHandle = userHandle ? utils.func.espaceHandleSign(utils.func.extractTikTokHandle(userHandle)) : ''
        } else if (platform === 'LinkedIn') {
          userHandle = this.normalizeLinkedInHandle(userHandle)
        }
        this.crawlInfluencerDetail(userHandle, this.searchInfluencer);
        this.addToSelectedInfluencers(userHandle, platform.toLowerCase());
      }
    },
    removeSelectedInfluencer(userHandle, platform) {
      let item = this.items.find(element => element.userHandle === userHandle && element.platform === platform);
      utils.func.removePairingElementFromArray(this.items, userHandle, 'object', 'userHandle', platform);
      utils.func.removePairingElementFromArray(this.selected, userHandle, 'string', 'handle', platform);
      utils.func.removeElementFromArray(this.ageItems, this.items.country, 'object', 'country')
      if (item.pairingID) {
        pairingAPIs.removePairing(item.pairingID).then(() => {
          console.log('removed', item);
        });
      }
      // Nyein - commented out old delete check
      // let text = "You won't be able to revert this!";
      // let item = this.items.find(element => element.userHandle === userHandle && element.platform === platform);
      // if (item.eliminationStatus === this.eliminationStatus.SELECTED) {
      //   text = 'This influencer is being selected by client. Do you still want to delete it?';
      // }
      // this.$swal({
      //   title: 'Are you sure?',
      //   icon: 'warning',
      //   showCancelButton: true,
      //   text
      // }).then(result => {
      //   if (result.value) {
      //     utils.func.removePairingElementFromArray(this.items, userHandle, 'object', 'userHandle', platform);
      //     utils.func.removePairingElementFromArray(this.selected, userHandle, 'string', 'handle', platform);
      //     utils.func.removeElementFromArray(this.ageItems, this.items.country, 'object', 'country')
      //     if (item.pairingID) {
      //       pairingAPIs.removePairing(item.pairingID).then(() => {
      //         console.log('removed', item);
      //       });
      //     }
      //   } else {
      //     this.selected.splice(); // Undo the unselect action, it will fire the event in 'InfluencerListModal'
      //   }
      // });
    },

    addToSelectedInfluencers(userHandle, platform, remarks = '') {
      let inf = {
        userHandle: userHandle,
        remarks,
        pairingStatus: '',
        eliminationStatus: '',
        gender: '',
        age_group: '',
        followers: '0',
        country: '',
        audience_interests: [],
        audience_credibility: '0',
        engagements: 0,
        engagement_rate: '0',
        payoutAmount: '0',
        isLoading: true,
        platform
      };
      utils.func.pushPairingElementToArray(this.items, inf, 'userHandle', 'object', platform);
      utils.func.pushPairingElementToArray(this.selected, {handle: userHandle, platform}, 'handle', 'object', platform);
    },

    getSuggestedInfluencerFromAI(campaignID, force) {
      this.loadingAI = true;
      pairingAPIs
        .getInfluencerFromAI(campaignID, force)
        .then(resp => {
          this.loadingAI = false;
          if (resp) {
            for (let inf of resp) {
              inf.platform = 'instagram'
              utils.func.pushElementToArray(this.suggestedInfluencers, inf, 'userHandle', utils.TYPE.OBJECT);
            }
          }
        })
        .catch(err => {
          this.loadingAI = false;
          console.error(err);
        });
    },
    refreshInfluencerDetail(ighandle, platform, pairingID) {
      pairingAPIs.refreshInfluencerDetails({ighandle, campaignID: this.campaign.id, platform: platform.toLowerCase(), pairingID}).then(response => {
        let index = this.items.findIndex(item => item.userHandle === ighandle && item.platform === platform.toLowerCase());
        let inf = this.items[index];
        if (response.success) {
          let data = response.data;
          inf = this.beautifyData(data);
        } else {
          inf.message = response.message || ''
          inf.socialDataErrMessage = response.socialDataErrMessage || ''
          inf.audience_credibility = response.audience_credibility || 0
          inf.audience_credibility_color = response.audience_credibility_color || '#4caf50'
          inf = this.initEditFields(inf)
        }
        inf.isLoading = false;
        inf.success = response.success;
        this.items[index] = inf;
        this.items = this.items.slice();
        this.setAgeGroupItems(this.items)
        this.getTopFiveAudienceInterests(this.items)
        this.setMultipleInfs()
        this.isLoading = false
      });
    },
    crawlInfluencerDetail(userHandle, platform, remarks = '') {
      pairingAPIs.crawlInfluencerDetails({userHandle, campaignID: this.campaign.id, platform: platform.toLowerCase(), platformName: this.platformName, options: this.optionVal, remarks}).then(response => {
        let index = this.items.findIndex(item => item.userHandle === userHandle && item.platform === platform.toLowerCase());
        let inf = this.items[index];
        if (response.success) {
          let data = response.data;
          inf = this.beautifyData(data);
        } else {
          inf.message = response.message || ''
          inf.socialDataErrMessage = response.socialDataErrMessage || ''
          inf.audience_credibility = response.audience_credibility || 0
          inf.audience_credibility_color = response.audience_credibility_color || '#4caf50'
          inf = this.initEditFields(inf)
        }
        inf.isLoading = false;
        inf.success = response.success;
        this.items[index] = inf;
        this.items = this.items.slice();
        this.setAgeGroupItems(this.items)
        this.getTopFiveAudienceInterests(this.items)
        this.setMultipleInfs()
      });
    },

    beautifyData(data) {
      let inf = {};
      inf = data.influencer_details;
      inf.influencer_details = Object.assign({}, data.influencer_details);
      const deliverablesDetails = data.deliverables_details || {};
      const additionalDetails = data.additional_details || {};
      const audienceDetails = data.avg_performances || null
      inf.remarks = additionalDetails.remarks;
      inf.contentFeature = additionalDetails.contentFeature;
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.eliminationReason = data.elimination_details.reason;
      inf.payoutAmount = Number(data.payout_details.amount);
      inf.predictedAmount = data.payout_details.predicted_amount || 0;
      inf.predictedAmountHigh = data.payout_details.predicted2_amount || 0;
      inf.multipliedPrice1 = data.payout_details.multipliedPrice1 || 0;
      inf.multipliedPrice2 = data.payout_details.multipliedPrice2 || 0;
      inf.min_payout = data.payout_details.min_payout || 0;
      inf.priceEffortMultiplier = Object.assign({}, data.payout_details.priceEffortMultiplier)
      inf.activity = data.activity && Array.isArray(data.activity) ? reverse(data.activity) : [];
      inf.deliverableDetails = deliverablesDetails
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.no_of_fb_posts = deliverablesDetails.no_of_fb_posts || 0;
      inf.no_of_xhs_posts = deliverablesDetails.no_of_xhs_posts || 0;
      inf.no_of_li_posts = deliverablesDetails.no_of_li_posts || 0;
      inf.no_of_x_posts = deliverablesDetails.no_of_x_posts || 0;
      inf.loading_whitelisting = deliverablesDetails.loading_whitelisting || '';
      inf.youtube = deliverablesDetails.youtube || 0;
      inf.exclusivity = deliverablesDetails.exclusivity || '';
      inf.physical_attendance = deliverablesDetails.physical_attendance || 0;
      inf.online_attendance = deliverablesDetails.online_attendance || 0;
      inf.customDeliverables = deliverablesDetails.custom || [];
      inf.pairingID = data.id;
      inf.lineUpIndex = data.lineUpIndex;
      inf.platform = inf.platform || 'instagram'
      inf.platformName = inf.platformName || inf.platform;
      inf.audience_genders = inf.audience_genders || []
      inf.lastReportDate = inf.lastReportDate || ''
      inf.options = data.options || 0
      inf.allOptions = data.allOptions || null
      // Aud Genders
      let audGenderRet = []
      if (Array.isArray(inf.audience_genders)) {
        let male = inf.audience_genders.find(a => a.code === 'MALE')
        if (male) audGenderRet.push(male)
        let female = inf.audience_genders.find(a => a.code === 'FEMALE')
        if (female) audGenderRet.push(female)
        audGenderRet = audGenderRet.map(gender => `${gender.code} (${(gender.weight * 100).toFixed(2)}%)`).join('\n')
      }
      inf.audGenderDisplay = audGenderRet
      inf.audience_genders = this.getGenderPieData(inf.audience_genders)
      inf.contentScriptForm = data.contentScriptForm;
      inf = this.initEditFields(inf)
      if (!inf.userHandle) inf.userHandle = inf.instagramHandle
      if (inf.platform === 'linkedin' || inf.platform === 'twitter' || inf.platform === 'x') {
        const platformHandle = inf.platform === 'linkedin'
          ? (inf.linkedinHandle || inf.userHandle || inf.instagramHandle)
          : (inf.twitterHandle || inf.userHandle || inf.instagramHandle)
        const trimmedHandle = typeof platformHandle === 'string' ? platformHandle.trim() : platformHandle

        inf.userHandle = trimmedHandle
        inf.influencer_details.userHandle = trimmedHandle
        if (inf.platform === 'linkedin') {
          inf.linkedinHandle = trimmedHandle
          inf.influencer_details.linkedinHandle = trimmedHandle
        } else {
          inf.twitterHandle = trimmedHandle
          inf.influencer_details.twitterHandle = trimmedHandle
        }
      }
      if (inf.platform && inf.platform === 'xiaohongshu') {
        inf.userHandle = inf.fullName
        inf.xhsID = inf.xhsID || inf.instagramHandle
      }
      inf.isGST = data.pairing_details.GST
      inf.GSTpercent = data.payout_details.GSTpercent
      if (inf.isGST && inf.GSTpercent) {
        inf.payoutAmount = inf.payoutAmount - Number(inf.GSTpercent)
      }
      if (data.payout_details) {
        inf.payoutStatus = data.payout_details.status || null
        inf.currency = data.payout_details.currency || 'SGD'
        if (inf.currency !== 'SGD') {
          inf.sgdAmt = utils.func.convertCurrency(inf.currency, inf.payoutAmount, this.currencyRates)
        }
      }
      inf.max_payout = data.payout_details.max_payout || inf.payoutAmount; // Current payout amount is default as maximum payout
      // for rate card
      if (inf.platform === 'tiktok') {
        inf.rateCard = this.rateCards.find(r => r.tiktokHandle === inf.userHandle)
      }
      if (inf.platform === 'instagram') {
        inf.rateCard = this.rateCards.find(r => r.instagramHandle === inf.userHandle)
      }
      if (audienceDetails) {
        inf.avg_likes = audienceDetails.avg_likes || ''
        inf.avg_comments = audienceDetails.avg_comments || ''
        inf.avg_views = audienceDetails.avg_views || ''
        inf.avg_reels_plays = audienceDetails.avg_reels_plays || ''
        inf.avg_saves = audienceDetails.avg_saves || ''
        inf.avg_shares = audienceDetails.avg_shares || ''
        inf.median_engagement_rate = audienceDetails.median_engagement_rate || ''
      }
      inf.topAudAges = []
      if (inf.audAges) {
        inf.audAges = sortBy(inf.audAges, 'lineupIndex');
        inf.audAges = inf.audAges.map(a => {
          if (!a.lineupIndex) {
            // put large num to show as last values in sorting
            a.lineupIndex = 999
          } else if (a.lineupIndex !== 999) {
            // top is used as two selected ages
            inf.topAudAges.push(a.code)
          }
          return a
        })
        inf.audAges = inf.audAges.sort((a, b) => a.lineupIndex - b.lineupIndex)
        if (inf.topAudAges.length) {
          // display is used to display as top two in more menu
          inf.audAgesDisplay = inf.audAges.slice(0, inf.topAudAges.length)
        }
      } else {
        inf.audAges = []
      }
      // for excel export aud ages display
      if (inf.audAges && inf.audAges.length) {
        inf.displayAudAge = inf.audAges.slice(0, 3)
        if (inf.displayAudAge.length) {
          inf.displayAudAge = inf.displayAudAge.map(d => `${d.code} (${(d.weight * 100).toFixed(2)}%)`).join('\n')
        }
      }
      inf.topCountries = []
      if (inf.countries) {
        inf.countries = sortBy(inf.countries, 'lineupIndex');
        inf.countries = inf.countries.map(a => {
          if (!a.lineupIndex) {
            // put large num to show as last values in sorting
            a.lineupIndex = 999
          } else if (a.lineupIndex !== 999) {
            // top is used as two selected countries
            inf.topCountries.push(a.name)
          }
          return a
        })
        if (inf.topCountries.length) {
          // display is used to display as top two in more menu
          inf.topCountryDisplay = inf.countries.slice(0, inf.topCountries.length)
        }
      } else {
        inf.countries = []
      }
      // for excel export
      // if (inf.topCountries && inf.topCountries.length) {
      //   inf.displaytopCountry = inf.topCountries[0]
      // } else {
      //   if (inf.countries.length) {
      //     inf.displaytopCountry = inf.countries[0].name
      //   }
      // }
      if (inf.countries && inf.countries.length) {
        inf.displaytopCountry = inf.countries.slice(0, 3)
        if (inf.displaytopCountry.length) {
          inf.displaytopCountry = inf.displaytopCountry.map(d => `${d.name} (${(d.weight * 100).toFixed(2)}%)`).join('\n')
        }
      }
      // Inf Interests
      if (inf.infInterests) {
        if (inf.infInterests.length) {
          inf.infInterestDisplay = inf.infInterests.map(i => i.name).join(',')
        }
      }
      // Aud Interests
      if (inf.audience_interests) {
        if (inf.audience_interests) {
          inf.audInterestDisplay = inf.audience_interests.map(i => i.name).join(',')
        }
      }
      // eng rate, median eng rate
      inf.engagementRateDisplay = ''
      if (inf.engagement_rate) inf.engagementRateDisplay = `${inf.engagement_rate}%`
      inf.medianEngRateDisplay = ''
      if (inf.median_engagement_rate) inf.medianEngRateDisplay = `${inf.median_engagement_rate}%`
      inf.genderEdit = false
      inf.followersEdit = false
      inf.ageGroupEdit = false
      inf.audAgesEdit = false
      inf.audCountryEdit = false
      return inf;
    },
    changePlatform(oldHandle, ighandle, platform, pairingID) {
      this.$swal({
        title: 'Switch Platform?',
        icon: 'warning',
        html: `<div style="text-align:center"><b>${oldHandle} → ${ighandle}</b></div><br>Changing the platform will reset the audience details.<br> Do you want to proceed?`,
        confirmButtonText: 'Switch Platform',
        cancelButtonText: 'Cancel',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.isLoading = true
          pairingAPIs.refreshInfluencerDetails({
            ighandle,
            campaignID: this.campaign.id,
            platform: platform.toLowerCase(),
            pairingID,
            isChange: true
          }).then(response => {
            let index = this.items.findIndex(item => item.pairingID === pairingID);
            let inf = this.items[index];
            if (response.success) {
              let data = response.data;
              inf = this.beautifyData(data);
              this.$swal({
                title: 'Success',
                icon: 'success',
                text: `Successfully Switched to ${ighandle}`,
                showCancelButton: false
              });
            } else {
              inf.message = response.message || ''
              inf.socialDataErrMessage = response.socialDataErrMessage || ''
              inf.audience_credibility = response.audience_credibility || 0
              inf.audience_credibility_color = response.audience_credibility_color || '#4caf50'
              inf = this.initEditFields(inf)
            }
            inf.isLoading = false;
            inf.success = response.success;
            this.items[index] = inf;
            this.items = this.items.slice();
            this.setAgeGroupItems(this.items)
            this.getTopFiveAudienceInterests(this.items)
            this.setMultipleInfs()
            this.isLoading = false
          });
        }
      });
    },
    async setMultipleInfs() {
      for (let item of this.items) {
        if (!item.influencerID) {
          continue
        }
        let infs = []
        await this.$store.dispatch('influencer/getInfluencerDetail', {
          id: item.influencerID
        })
        this.$set(item, 'isPlatformConnected', this.isCurrentPlatformConnected(item, this.infDetail))
        if (this.infDetail.instagram) {
          infs.push({
            handle: this.infDetail.instagram.instagramHandle,
            instagramID: this.infDetail.instagram.instagramID,
            picture: this.infDetail.audience ? this.infDetail.audience.user_profile.picture : this.infDetail.instagram.picture,
            instagram: true,
            platform: 'instagram',
            pairingID: item.pairingID
          })
        }
        if (this.infDetail.tiktok) {
          infs.push({
            handle: this.infDetail.tiktok.tiktokHandle,
            tiktokID: this.infDetail.tiktok.tiktokID,
            picture: this.infDetail.tiktokaudience ? this.infDetail.tiktokaudience.user_profile.picture : this.infDetail.tiktok.picture,
            tiktok: true,
            platform: 'tiktok',
            pairingID: item.pairingID
          })
        }
        if (this.infDetail.youtube) {
          infs.push({
            handle: this.infDetail.youtube.youtubeHandle,
            youtubeID: this.infDetail.youtube.youtubeID,
            picture: this.infDetail.youtubeaudience ? this.infDetail.youtubeaudience.user_profile.picture : this.infDetail.youtube.picture,
            youtube: true,
            platform: 'youtube',
            pairingID: item.pairingID
          })
        }
        if (this.infDetail.xiaohongshu) {
          infs.push({
            handle: this.infDetail.xiaohongshu.xhsHandle,
            xhsID: this.infDetail.xiaohongshu.xhsID,
            picture: this.infDetail.xiaohongshu ? this.infDetail.xiaohongshu.profilePicture : '',
            xhs: true,
            platform: 'xiaohongshu',
            pairingID: item.pairingID
          })
        }
        if (this.infDetail.facebook) {
          const facebookHandle = this.infDetail.facebook.handle || this.infDetail.facebook.facebookHandle || this.infDetail.facebook.facebookId
          if (facebookHandle) {
            infs.push({
              handle: this.normalizeFacebookHandle(facebookHandle),
              facebookID: this.infDetail.facebook.facebookId,
              picture: this.infDetail.facebook ? this.infDetail.facebook.profilePicture : '',
              facebook: true,
              platform: 'facebook',
              pairingID: item.pairingID
            })
          }
        }
        if (this.infDetail.linkedin && this.infDetail.linkedin.linkedinHandle) {
          infs.push({
            handle: this.normalizeLinkedInHandle(this.infDetail.linkedin.linkedinHandle),
            picture: '',
            linkedin: true,
            platform: 'linkedin',
            pairingID: item.pairingID
          })
        }
        if (this.infDetail.twitter && this.infDetail.twitter.twitterHandle) {
          infs.push({
            handle: this.normalizeTwitterHandle(this.infDetail.twitter.twitterHandle),
            picture: '',
            twitter: true,
            platform: 'twitter',
            pairingID: item.pairingID
          })
        }
        item.multipleInfs = infs
      }
      this.items = Object.assign([], this.items)
    },
    isCurrentPlatformConnected(item, influencer) {
      const platform = String(item.platform || (item.influencer_details && item.influencer_details.platform) || 'instagram').toLowerCase()
      const platformKey = platform === 'x' ? 'twitter' : platform
      const connectedPlatformKeys = ['instagram', 'tiktok', 'youtube', 'xiaohongshu', 'facebook', 'linkedin', 'twitter']
      return !connectedPlatformKeys.includes(platformKey) || Boolean(influencer && influencer[platformKey])
    },
    searchManually(searchType) {
      switch (searchType) {
        case SearchTypeEnum.KEYWORD:
          this.searchByKeyword();
          break;
        case SearchTypeEnum.HANDLE:
          this.searchByHandle(this.igHandle);
          this.igHandle = ''; // Reset the search box
          break;
      }
    },
    searchByHandle(ighandle) {
      if (!ighandle || ighandle === '') {
        let errMsg = ''
        if (this.searchInfluencer === 'Instagram') {
          errMsg = 'Please enter the Instagram Handle'
        } else if (this.searchInfluencer === 'Facebook') {
          errMsg = 'Please enter the Facebook ID'
        } else if (this.searchInfluencer === 'LinkedIn') {
          errMsg = 'Please enter the LinkedIn Handle'
        } else if (this.searchInfluencer === 'Twitter') {
          errMsg = 'Please enter the X (Twitter) Handle'
        } else if (this.searchInfluencer === 'Youtube') {
          errMsg = 'Please enter the Youtube ID'
        } else if (this.searchInfluencer === 'TikTok') {
          errMsg = 'Please enter the TikTok Handle'
        } else {
          errMsg = 'Please enter the TikTok Handle'
        }
        this.$swal({
          title: 'Error',
          text: errMsg,
          type: 'info'
        });
        return;
      }
      if (this.searchInfluencer === 'Facebook') {
        ighandle = this.normalizeFacebookHandle(ighandle)
      } else if (this.searchInfluencer === 'LinkedIn') {
        ighandle = this.normalizeLinkedInHandle(ighandle)
      } else if (this.searchInfluencer === 'Twitter') {
        ighandle = this.normalizeTwitterHandle(ighandle)
      }
      if (/^https?:\/\//i.test(ighandle) && this.searchInfluencer !== 'Xiaohongshu') {
        this.$swal({
          title: 'Error!',
          icon: 'error',
          showCancelButton: false,
          text: 'Invalid Handle'
        });
        return;
      }
      this.select(ighandle, this.searchInfluencer);
    },
    normalizeFacebookHandle(value) {
      let handle = (value || '').trim()
      const facebookUrl = handle.match(/^(?:https?:\/\/)?(?:www\.|m\.)?(?:facebook\.com|fb\.com)\/([^/?#]+)/i)
      if (facebookUrl) {
        handle = facebookUrl[1]
        if (handle.toLowerCase() === 'profile.php') {
          const profileId = String(value).match(/[?&]id=([^&#]+)/i)
          if (profileId) handle = profileId[1]
        }
      }
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim()
    },
    normalizeLinkedInHandle(value) {
      let handle = (value || '').trim()
      const linkedinUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([^/?#]+)/i)
      if (linkedinUrl) handle = linkedinUrl[1]
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim()
    },
    normalizeTwitterHandle(value) {
      let handle = (value || '').trim()
      const twitterUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?(?:x|twitter)\.com\/([^/?#]+)/i)
      if (twitterUrl) handle = twitterUrl[1]
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim()
    },
    searchByKeyword() {
      this.isLoading = true;
      this.searchKeywordAction = utils.func.makeid(5);
    },
    resultFromSearchKeyword(value) {
      this.isLoading = false;
      if (value.success) {
        this.currentKeywordSearch = value.keyword;
        this.historySearchResult = value;
        this.showResult(value);
      }
    },
    isBudgetOver(target, current) {
      return current / target > 1;
    },
    showResult(result) {
      this.showInfluencerSearchResult = true;
      this.influencerSearchResult = Object.assign({}, result);
      this.selected.splice();
    },
    getPairedInfluencers(campaignID) {
      this.isLoading = true
      pairingAPIs.getPairedInfluencersByCampaign(campaignID, true).then(resp => {
        this.isLoading = false
        if (resp) {
          let items = [];
          let selected = [];
          for (let data of resp) {
            let inf = this.beautifyData(data);
            inf.isLoading = false;
            inf.success = true;
            items.push(inf);
            selected.push({handle: inf.userHandle, platform: inf.platform});
          }
          let pairedInfluencer = Object.assign([], items);
          pairedInfluencer = pairedInfluencer.filter(p => {
            if (p.allOptions) {
              return true
            }
            if (this.optionVal === 0) {
              return !p.options || p.options === this.optionVal
            } else {
              return p.options && p.options === this.optionVal
            }
          })
          this.items = pairedInfluencer.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          this.filteredItems = this.items
          this.selected = Object.assign([], selected);
          this.setAgeGroupItems(this.items)
          this.getTopFiveAudienceInterests(this.items)
          this.checkOpenPayoutEditDialog()
          this.setMultipleInfs()
          this.handleTableUpdate(this.items)
          this.detectCurrency(this.filteredItems)
          if (this.unlockCogs) {
            this.changeLock(this.campaign, false)
            this.$emit('setUnlockCogs', false)
          }
        }
      }).catch(error => {
        console.log(error)
        this.isLoading = false
      })
    },
    setAgeGroupItems(items) {
      let arrayItem = []
      items.map(item => {
        if (item.age_group) {
          arrayItem.push(item.age_group)
        }
      })
      this.ageItems = [...new Set(arrayItem)]
    },
    goToStep(step) {
      this.pairingStepper = step;
    },
    getAge(birthday) {
      return moment().format('YYYY') - moment(birthday).format('YYYY');
    },
    formatTime(value) {
      return moment(value).format('YYYY-MM-DD hh:mm:ss');
    },
    formatCurrency(number) {
      return utils.func.formatCurrency(number);
    },
    formatNumber(number) {
      return utils.func.formatNumber(number);
    },
    formatUploadedDate(value) {
      return moment(value).format('DD/MM/YYYY');
    },
    handleTableUpdate(items) {
      this.lineUpItems = items
      this.updateLineUp()
      // this.disableSaveLineUp = false
    },
    actionSelectChange() {
      this.actionSelected = this.items.filter(i => i.isDelete)
    },
    clearFilter() {
      this.searchGender = ''
      this.searchAge = ''
      this.searchLocation = ''
      this.searchPairingStatus = ''
      this.searchAudCrediblity = ''
      this.getPairedInfluencers(this.campaign.id);
    },
    clearPairingData() {
      this.items = []
      this.filteredItems = []
      this.currencyTotals = {}
    },
    clearActionSelected() {
      this.items = this.items.map(inf => {
        delete inf.isDelete;
        return inf
      })
      this.actionSelected = []
    },
    genderOnChangeHandler() {
      if (this.searchAge && this.searchLocation) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchAge) {
        this.items = this.filteredItems.filter(item => item.age_group === this.searchAge.toString().toUpperCase() && item.gender === this.searchGender.toString().toUpperCase())
      } else if (this.searchLocation) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchPairingStatus || this.searchPairingStatus === config.pairingStatus.NEW) {
        this.items = this.filteredItems.filter(item => item.pairingStatus === this.searchPairingStatus)
      } else if (this.searchAudCrediblity) {
        let searchedCred = this.audCrediblityFilters.find(aud => aud.name === this.searchAudCrediblity)
        this.items = this.filteredItems.filter(item => item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max)
      } else this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase())
      this.getTopFiveAudienceInterests(this.items)
    },
    ageOnChangeHandler() {
      if (this.searchGender && this.searchLocation) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchGender) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.age_group === this.searchAge.toString().toUpperCase())
      } else if (this.searchLocation) {
        this.items = this.filteredItems.filter(item => item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchPairingStatus || this.searchPairingStatus === config.pairingStatus.NEW) {
        this.items = this.filteredItems.filter(item => item.pairingStatus === this.searchPairingStatus)
      } else if (this.searchAudCrediblity) {
        let searchedCred = this.audCrediblityFilters.find(aud => aud.name === this.searchAudCrediblity)
        this.items = this.filteredItems.filter(item => item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max)
      } else this.items = this.filteredItems.filter(item => item.age_group === this.searchAge.toString().toUpperCase())
      this.getTopFiveAudienceInterests(this.items)
    },
    countryOnChangeHandler() {
      if (this.searchAge && this.searchGender) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchAge) {
        this.items = this.filteredItems.filter(item => item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchGender) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchPairingStatus || this.searchPairingStatus === config.pairingStatus.NEW) {
        this.items = this.filteredItems.filter(item => item.pairingStatus === this.searchPairingStatus)
      } else if (this.searchAudCrediblity) {
        let searchedCred = this.audCrediblityFilters.find(aud => aud.name === this.searchAudCrediblity)
        this.items = this.filteredItems.filter(item => item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max)
      } else this.items = this.filteredItems.filter(item => item.country === this.searchLocation)
      this.getTopFiveAudienceInterests(this.items)
    },
    pairingStatusOnChangeHandler() {
      this.items = utils.func.refreshJSON(this.filteredItems)
      if (this.searchAge && this.searchGender) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchAge) {
        this.items = this.filteredItems.filter(item => item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchGender) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchLocation) {
        this.items = this.filteredItems.filter(item => item.country === this.searchLocation)
      } else if (this.searchPairingStatus || this.searchPairingStatus === config.pairingStatus.NEW) {
        this.items = this.filteredItems.filter(item => item.pairingStatus === this.searchPairingStatus)
      } else if (this.searchAudCrediblity) {
        let searchedCred = this.audCrediblityFilters.find(aud => aud.name === this.searchAudCrediblity)
        this.items = this.filteredItems.filter(item => item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max)
      }
      this.getTopFiveAudienceInterests(this.items)
    },
    getCountries() {
      influencerAPIs.getCountries().then(countries => {
        this.locationItems = countries.map(item => item.name);
      });
    },
    getTopFiveAudienceInterests(items) {
      let audienceInterests = []
      this.topFiveAudienceInterests = []
      items.map(item => {
        if (item.audience_interests) {
          audienceInterests = item.audience_interests
        }
        this.topFiveAudienceInterests.push([...audienceInterests].sort((a, b) => b.weight - a.weight).slice(0, 5))
      })
      // console.log('🚀 ~ file: ViewPairingModal.vue ~ line 1421 ~ getTopFiveAudienceInterests ~ this.topFiveAudienceInterests', this.topFiveAudienceInterests)
    },
    saveLineUp () {
      this.updateLineUp()
      this.$swal.fire({
        type: 'success',
        title: 'Saved!',
        showCancelButton: false,
        width: 300
      });
    },
    confirmDelete() {
      let text = "You won't be able to revert this!";
      this.$swal({
        title: 'Are you sure to delete?',
        icon: 'warning',
        showCancelButton: true,
        text
      }).then(result => {
        if (result.value) {
          this.isLoading = true
          for (let item of this.actionSelected) {
            this.executeMethod('delete', item)
          }
          this.isLoading = false
          this.$swal({
            text: 'Successfully Deleted.',
            type: 'success'
          });
          this.clearActionSelected()
        }
      });
    },
    saveEditingData(items = []) {
      this.calcMeasurements(this.items)
      // if (this.isBudgetOver(this.budget, this.measurement.budget)) {
      //   this.reqApprovalDialog = true
      //   // this.$swal({
      //   //   title: 'Warning',
      //   //   icon: 'warning',
      //   //   text: `The current budget for this campaign is exceeded the limited. Please check again`
      //   // })
      //   return;
      // }
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          this.isEditing = true;
          if (items.length > 0) {
            this.items = items
          }
          let data = this.items.filter(item => item.editPairing && item.editPairing === true)
          data = data.map(item => {
            return Object.assign({}, {
              id: item.pairingID,
              platformName: item.platformName,
              followers: item.followers,
              remarks: item.remarks,
              contentFeature: item.contentFeature,
              payoutAmount: item.payoutAmount,
              status: item.pairingStatus,
              eliminationStatus: item.pairingStatus === this.pairingStatus.ACCEPTED.value ? this.eliminationStatus.SELECTED : item.eliminationStatus,
              GSTpercent: 0,
              GST: false
            })
          })
          // Submit request to save edited pairing data
          pairingAPIs
          .saveEditedPairingData(data)
          .then(response => {
            // Update submitting status
            this.isEditing = false;
            this.cancelEdit()
            this.clearActionSelected()
            data.map(item => {
              let itemIndex = this.items.findIndex(i => i.pairingID === item.id)
              if (itemIndex !== -1) {
                this.items[itemIndex].isGST = false
                this.items[itemIndex].max_payout = item.payoutAmount
              }
            })
            // Show success message
            this.$swal({
              text: 'Pairing Updated',
              type: 'success'
            });
          })
          .catch(error => {
            // Update submitting status
            this.isEditing = false;
            // Request failed.
            console.log('error', error);
            this.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    // async getRateCard(item) {
    //   let influencerID = item.influencerID
    //   this.inputRates = {}
    //   if (influencerID) {
    //     influencerAPIs.getInfluencer(influencerID).then(item => {
    //       this.inputRates = item.inputedRates || {}
    //       if (this.inputRates.pricingDecks && this.inputRates.pricingDecks.length === 0) {
    //         this.isPricingDeskEmpty = true
    //       }
    //     })
    //   }
    //   await this.getRateCardFormLists(item)
    // },
    // async getRateCardFormLists(item) {
    //   this.rateCardFormRates = {}
    //   let filters = {}
    //   if (item.platform) {
    //     if (item.platform === 'tiktok') {
    //       filters.tiktokHandle = item.instagramHandle
    //     } else {
    //       filters.instagramHandle = item.instagramHandle
    //     }
    //   } else filters.instagramHandle = item.instagramHandle
    //   await this.$store.dispatch('influencer/getRateCardLists', { filters })
    //   if (this.rateCards && this.rateCards.length > 0) {
    //     this.rateCardFormRates = this.rateCards[0]
    //   }
    // },
    async getRateCardLists() {
      await this.$store.dispatch('influencer/getRateCardLists', {filters: {}})
    },
    calcMeasurements(newList) {
      this.measurement.total = 0;
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      newList.forEach(item => {
        if (item.eliminationStatus !== this.eliminationStatus.ELIMINATED) {
          // If influencer isn't eliminated
          if (item.pairingStatus === this.pairingStatus.ACCEPTED.value) {
            this.measurement.total += Number(this.calculateContents(item));
            this.measurement.outreach += Number(this.calculateOutreach(item));
            this.measurement.engagement += Number(this.calculateEngagement(item));
            let amt = Number(item.payoutAmount || 0)
            if (item.currency !== 'SGD') {
              // convert rate if not sgd
              let rate = this.currencyRates[item.currency]
              amt = Number(amt / rate).toFixed(2)
            }
            this.measurement.budget += Number(amt || 0);
          }
        }
      });
      this.measurement.outreachPercentage = ((this.measurement.outreach / this.campaign.outreach) * 100).toFixed(2);
      this.measurement.engagementPercentage = ((this.measurement.engagement / this.campaign.engagement) * 100).toFixed(2);
      this.measurement.cogsPercentage = ((this.measurement.budget / this.campaign.budget) * 100).toFixed(2);
      let content = (this.measurement.total / (this.campaign.min_content || this.campaign.min_influencer || 1)) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
    },
    getFileType(item) {
      let filename = item.url.substring(item.url.lastIndexOf('/') + 1)
      let fileExt = filename.split('.')[1];

      return fileExt
    },
    async igHandleBulkUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      if (!uploadedFiles || uploadedFiles.length === 0) {
        this.$swal({
          type: 'info',
          text: 'No file uploaded'
        });
        return;
      }
      let handles = await new Promise((resolve, reject) => {
        var fr = new FileReader();
        fr.onload = (e) => {
          const tmp = utils.func.parserToJson(e.target.result);
          resolve(tmp)
        };
        fr.readAsArrayBuffer(e.target.files[0]);
        fr.onerror = reject;
      });
      let handleItems = []
      for (const items of handles) {
        for (const record of items) {
          if (record.handle) {
            if (record.type === 'instagram') {
              record.handle = record.handle ? utils.func.espaceHandleSign(utils.func.regexMatchIg(record.handle, globalConfig.regexPattern.instagram_profile)) : ''
            } else if (record.type === 'tiktok') {
              record.handle = record.handle ? utils.func.espaceHandleSign(utils.func.extractTikTokHandle(record.handle)) : ''
            }
            handleItems.push({handle: record.handle, platform: record.type, remarks: record.remarks})
          }
        }
      }
      this.uploadBulkHandle(handleItems)
    },
    uploadBulkHandle(handleItems) { // handleItems : array
      if (handleItems.length === 0) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          text: 'No Influencer Handle Found'
        });
        return;
      }
      let vm = this
      this.resetBulkProgress()
      this.bulkProgress.show = true
      this.bulkProgress.complete = handleItems.length
      let importSelected = []
      let interval = 100
      handleItems.forEach((el, index) => {
        setTimeout(() => {
          let handleItem = el
          if (vm.selected.find(e => e.handle === handleItem && e.platform === el.platform)) {
            importSelected.push({handle: handleItem.handle, platform: handleItem.platform})
          } else {
            vm.crawlInfluencerDetail(handleItem.handle, handleItem.platform, handleItem.remarks);
            vm.addToSelectedInfluencers(handleItem.handle, handleItem.platform, handleItem.remarks);
            console.log(`🚀 ~ IG Handle: ${handleItem.handle}`)
          }
          this.bulkProgress.processing = index + 1
          if (this.bulkProgress.complete === this.bulkProgress.processing) {
            this.bulkProgress.show = false
            this.showAlreadySelectedAlert(importSelected)
          }
        }, index * interval);
      });
      this.$refs.igBulkHandle.value = null;
    },
    showAlreadySelectedAlert(importSelected) {
      if (importSelected.length > 0) { // if already selected exists, show after completed
        let displayBlock = ''
        importSelected.map(a => {
          displayBlock += `<span class="v-chip theme--light v-size--default" style="font-weight:bold;margin:5px;background:red;color:#fff">
            <span class="v-chip__content">${a}</span>
          </span>`
        })
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: `Influencers being selected: <div>${displayBlock}</div>`
        });
      }
      return;
    },
    resetBulkProgress() {
      this.bulkProgress.processing = 0
      this.bulkProgress.complete = 0
      this.bulkProgress.show = false
    },
    openEditItem(itemID, itemName) {
      if (this.disableLockedCOGS) {
        return
      }
      let index = this.items.findIndex(i => i.pairingID === itemID)
      if (itemName === 'payout') {
        if (this.items[index].payoutStatus === this.payoutStatus.CONFIRMED) {
          return
        }
      }
      if (itemName === 'status') {
        if (this.campaign.lockedCOGS || this.items[index].payoutStatus === this.payoutStatus.CONFIRMED) {
          return
        }
      }
      this.items[index][itemName + 'Edit'] = true
      this.items[index].editPairing = true
      this.oldEditItem = utils.func.refreshJSON(this.items[index])
      this.disableSaveEdit = false
    },
    cancelEdit() {
      this.items = this.items.map(inf => {
        inf = this.initEditFields(inf)
        return inf
      })
      this.disableSaveEdit = true
    },
    initEditFields(inf) {
      inf.platformNameEdit = false;
      inf.remarkEdit = false;
      inf.contentFeatureEdit = false;
      inf.payoutEdit = false;
      inf.statusEdit = false;
      inf.editPairing = false;
      return inf
    },
    changeBulkPairingStatus(status) {
      let items = utils.func.refreshJSON(this.items)
      items = items.map(i => {
        if (i.isDelete) {
          i.pairingStatus = status;
          i.editPairing = true
        }
        return i;
      })
      this.saveEditingData(items)
    },
    selectAllPairings($event) {
      if (!$event.value) {
        this.items = this.items.map(i => { i.isDelete = false; return i; })
      } else {
        this.items = this.items.map(i => {
          if (i.payoutStatus !== this.payoutStatus.CONFIRMED) {
            i.isDelete = true
          }
          return i;
        })
      }
      this.actionSelectChange()
    },
    updatePairingDisplayStatus() {
      let data = Object.assign({}, {
        pairingDisplayStatus: this.campaign.pairingDisplayStatus
      })
      let formData = new FormData();
      formData.append('data', JSON.stringify(data));
      // Submit request to upload file
      campaignAPIs
        .updatePairingDisplayStatus(this.campaign.id, formData)
        .then(response => {
          console.log('successfully updated!')
        })
      .catch(error => {
        // Request failed.
        console.log('error', error);
        this.$swal({
          text: error,
          type: 'error'
        });
      });
    },
    displayFields(field) {
      if (this.campaign.pairingDisplayStatus !== undefined) {
        if (this.campaign.pairingDisplayStatus[field]) {
          return true
        }
      }
      return false
    },
    renderRemark(remark) {
      if (remark !== undefined && remark !== null) {
        return remark.replace(/\n/g, '<br>');
      }
      return '-'
    },
    downloadSampleUpload() {
      var link = document.createElement('a');
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', 'sample_bulkupload');
      link.href = '/static/sample/sample_bulkupload.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    getGenderPieData(audienceGenders) {
      if (Array.isArray(audienceGenders)) {
        let ret = []
        let male = audienceGenders.find(a => a.code === 'MALE')
        if (male) ret.push(male)
        let female = audienceGenders.find(a => a.code === 'FEMALE')
        if (female) ret.push(female)
        return ret.map(gender => (gender.weight * 100).toFixed(2))
      }
    },
    displayGSTText(item) {
      let currency = item.currency
      if (item.isGST) {
        // sum gst to payout amount, parsefloat to avoid string concat for both payoutAmount and GST
        return `The amount show here is excluding GST. If GST is included, the payout amount is: 
        ${currency} ${this.$options.filters.thousandSeprator(parseFloat(item.payoutAmount) + parseFloat(item.GSTpercent || 0))}`
      }
      return item.min_payout ? currency + ' ' + (item.min_payout) + ' - ' + currency + ' ' + (item.max_payout) : currency + ' ' + this.$options.filters.thousandSeprator(item.max_payout)
    },
    openLockedPayoutEditDialog(item) {
      this.lockedPayout = true
      this.payoutEditPairing = item
      this.editPayoutDialog = true
      this.$router.push({
        path: window.location.pathname,
        query: {
          campaignID: this.campaign.id,
          handle: item.instagramHandle,
          payoutConfirm: true
        }
      })
    },
    openLockedCOGSDialog(item) {
      this.$swal({
        title: 'Send Unlock Request',
        html: 'Are you sure to send request to unlock COGS?',
        confirmButtonText: 'Send',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          const reqData = {
            campaignID: item.id
          }
          await this.$store.dispatch('pairing/requestPayoutEdit', reqData)
          if (this.requestedPayoutEdit) {
            this.$swal({
              text: 'Successfully Requested.',
              type: 'success'
            })
          }
        }
      })
    },
    async changeLock(item, status) {
      const lockTxt = status ? 'Lock' : 'Unlock'
      this.$swal({
        title: `Are you sure to ${lockTxt}?`,
        icon: 'warning',
        confirmButtonText: lockTxt,
        showCancelButton: true
      }).then(async (result) => {
        if (result.value) {
          let updateObj = {
            id: item.id,
            lockedCOGS: status
          }
          if (status === false) {
            updateObj.unlockCogsEmail = true
          }
          const updateData = [
            updateObj
          ]
          await this.$store.dispatch('campaign/updateCampaignByIds', updateData)
          if (!this.campaignUpdated) {
            this.$swal({
              text: 'Error Campaign Update.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: `Successfully ${lockTxt}ed.`,
            type: 'success'
          });
          this.$set(item, 'lockedCOGS', status)
          this.$emit('cogs-lock-changed', item.id, status)
        }
        this.getPairedInfluencers(this.campaign.id)
      })
    },
    savedGetApproval() {
      this.getPairedInfluencers(this.campaign.id)
    },
    openPayoutEditDialog(item) {
      this.lockedPayout = false
      this.payoutEditPairing = item
      this.editPayoutDialog = true
    },
    openReqApprovalDialog(updateData) {
      this.reqAmt = Number(updateData.amount)
      this.reqReasons = updateData.reasons
      this.reqApprovalDialog = true
    },
    checkOpenPayoutEditDialog() {
      // this will check from route params to open payout confirmation dialog by given handle
      if (this.$route.query.payoutConfirm && this.$route.query.handle) {
        let handle = this.$route.query.handle
        let matchItem = this.filteredItems.find(f => f.instagramHandle === handle)
        if (matchItem) {
          if (matchItem.payoutStatus === this.payoutStatus.CONFIRMED) {
            this.openLockedPayoutEditDialog(matchItem)
          } else {
            this.openPayoutEditDialog(matchItem)
          }
        }
      }
    },
    changePairingStatus(item) {
      if (item.pairingStatus === config.pairingStatus.ACCEPTED) {
        const totalDeliverables = campaignHelper.getTotalDeliverables(item.deliverableDetails)
        if (totalDeliverables <= 0) {
          this.$swal({
            text: `Please submit deliverables to accept.`,
            type: 'warning'
          });
          // set old pairing status if no deliverables submitted.
          this.items = this.items.map(i => {
            if (i.pairingID === item.pairingID) {
              if (this.oldEditItem) {
                i.pairingStatus = this.oldEditItem.pairingStatus
                i.statusEdit = false
              }
              if (item.pairingStatus === this.pairingStatus.ACCEPTED.value) {
                i.eliminationStatus = this.eliminationStatus.SELECTED
              }
            }
            return i
          })
          return
        }
        if (item.payoutAmount === 0) {
          this.$swal({
            html: `The Payout is 0$.<br>Please confirm this creator doesn’t need payment.`,
            type: 'warning'
          });
        }
      }
      this.items = this.items.map(i => {
        if (i.pairingID === item.pairingID) {
          if (item.pairingStatus === this.pairingStatus.ACCEPTED.value) {
            i.eliminationStatus = this.eliminationStatus.SELECTED
          } else {
            console.log('selected', item.pairingStatus)
            i.eliminationStatus = this.eliminationStatus.NEW
          }
        }
        return i
      })
    },
    openRateCardView(rateCard) {
      window.open(`/influencers/rate-cards?id=${rateCard.id}`, '_blank')
    },
    changePairingColEdit(colName, item, status) {
      let matchItemIdx = this.items.findIndex(f => f.pairingID === item.pairingID)
      if (matchItemIdx !== -1) {
        this.items[matchItemIdx][colName] = status
        this.items = utils.func.refreshJSON(this.items)
      }
    },
    async updatePairingCol(item, field) {
      this.isLoading = true
      let updatePairings = []
      if (field === 'platformName') {
        item.influencer_details.platformName = item.platformName
        updatePairings.push({
          id: item.pairingID,
          'influencer_details': item.influencer_details
        })
      }
      if (field === 'gender') {
        item.influencer_details.gender = item.gender
        updatePairings.push({
          id: item.pairingID,
          'influencer_details': item.influencer_details
        })
      }
      if (field === 'followers') {
        item.influencer_details.followers = item.followers
        updatePairings.push({
          id: item.pairingID,
          'influencer_details': item.influencer_details
        })
      }
      if (field === 'age_group') {
        item.influencer_details.age_group = item.age_group
        updatePairings.push({
          id: item.pairingID,
          'influencer_details': item.influencer_details
        })
      }
      if (field === 'topAudAges') {
        if (!item.influencer_details.audAges) {
          item.influencer_details.audAges = []
        }
        // clear up manual items first to set new manuals
        item.influencer_details.audAges = item.influencer_details.audAges.filter(c => !c.manual)
        // remove lineupindex  to reorder
        item.influencer_details.audAges = item.influencer_details.audAges.map(a => {
          delete a.lineupIndex
          return a
        })
        let idx = 1
        for (let fieldItem of item[field]) {
          let matchItemIdx = item.influencer_details.audAges.findIndex(a => a.code === fieldItem)
          if (matchItemIdx !== -1) {
            item.influencer_details.audAges[matchItemIdx].lineupIndex = idx
          } else {
            // if no aud ages match, create manual one
            item.influencer_details.audAges.push({
              code: fieldItem,
              weight: 0,
              lineupIndex: idx,
              manual: true
            })
          }
          idx += 1
        }
        updatePairings.push({
          id: item.pairingID,
          'influencer_details': item.influencer_details
        })
      }
      if (field === 'topCountries') {
        if (!item.influencer_details.countries) {
          item.influencer_details.countries = []
        }
        item.influencer_details.countries = item.influencer_details.countries.filter(c => !c.manual)
        item.influencer_details.countries = item.influencer_details.countries.map(a => {
          delete a.lineupIndex
          return a
        })
        let idx = 1
        for (let fieldItem of item[field]) {
          let matchItemIdx = item.influencer_details.countries.findIndex(a => a.name === fieldItem)
          if (matchItemIdx !== -1) {
            item.influencer_details.countries[matchItemIdx].lineupIndex = idx
          } else {
            item.influencer_details.countries.push({
              name: fieldItem,
              weight: 0,
              lineupIndex: idx,
              manual: true
            })
          }
          idx += 1
        }
        updatePairings.push({
          id: item.pairingID,
          'influencer_details': item.influencer_details
        })
      }
      let formData = new FormData();
      formData.append('pairings', JSON.stringify(updatePairings));
      let resp = await pairingAPIs.updatePairings(formData)
      if (resp) {
        let matchItemIdx = this.items.findIndex(f => f.pairingID === item.pairingID)
        if (matchItemIdx !== -1) {
          this.items[matchItemIdx][field] = item[field]
          if (field === 'topAudAges') {
            item.influencer_details.audAges = sortBy(item.influencer_details.audAges, 'lineupIndex')
            this.items[matchItemIdx].audAges = Object.assign([], item.influencer_details.audAges)
            this.items[matchItemIdx].audAgesDisplay = Object.assign([], this.items[matchItemIdx].audAges.splice(0, item.topAudAges.length))
            this.items[matchItemIdx].audAgesEdit = false
          }
          if (field === 'topCountries') {
            item.influencer_details.countries = sortBy(item.influencer_details.countries, 'lineupIndex')
            this.items[matchItemIdx].countries = Object.assign([], item.influencer_details.countries)
            this.items[matchItemIdx].topCountryDisplay = Object.assign([], this.items[matchItemIdx].countries.splice(0, item.topCountries.length))
            this.items[matchItemIdx].audCountryEdit = false
          }
          if (field === 'gender') {
            this.items[matchItemIdx].genderEdit = false
            this.items[matchItemIdx].influencer_details.gender = item.influencer_details.gender
          }
          if (field === 'followers') {
            this.items[matchItemIdx].followersEdit = false
            this.items[matchItemIdx].influencer_details.followers = item.influencer_details.followers
          }
          if (field === 'platformName') {
            this.items[matchItemIdx].platformNameEdit = false
            this.items[matchItemIdx].influencer_details.platformName = item.influencer_details.platformName
          }
          if (field === 'age_group') {
            this.items[matchItemIdx].ageGroupEdit = false
            this.items[matchItemIdx].influencer_details.age_group = item.influencer_details.age_group
          }
          let tmp = Object.assign([], this.items)
          this.items = []
          this.items = utils.func.refreshJSON(tmp)
        }
      }
      this.isLoading = false
    },
    checkSelectLimit(item, field) {
      if (item[field].length > 2) {
        item[field].pop()
      }
    },
    detectCurrency(items) {
      // detect different currency values and set to currency object
      let currencies = globalConfig.currencies
      currencies.map(c => {
        this.currencyTotals[c] = 0
      })
      items.map(item => {
        if (item.currency && item.pairingStatus === this.pairingStatus.ACCEPTED.value) {
          this.currencyTotals[item.currency] += Number(item.payoutAmount || 0)
        }
      })
    },
    isPendingActivity(item) {
      if (item.activity) {
        if (Array.isArray(item.activity)) {
          let matchPending = item.activity.filter(item => item.status === 'pending')
          if (matchPending.length) return true
        }
      }
      return false
    },
    updatePagination(pagination) {
      this.showPie = false
      setTimeout(() => {
        this.showPie = true
      }, 500)
    },
    checkHoverSortIcon() {
      let vm = this
      setInterval(() => {
        vm.disableSort = true
        const elements = document.querySelectorAll('.move-cursor')
        elements.forEach(element => {
          if (element) {
            if (element.matches(':hover')) {
              vm.disableSort = false
            }
          }
        })
      }, 1)
    },
    checkReportDate(date) {
      if (!date) return false
      if (moment(date).format('YYYY-MM-DD') < moment().subtract(182, 'days').format('YYYY-MM-DD')) {
        return true
      }
      return false
    },
    async moveOption(targetOption) {
      this.isLoading = true
      for (let selectOne of this.actionSelected) {
        // The bulk-action menu supplies the destination option. Do not invert
        // it as the older row-level toggle did.
        let updatePairings = [{
          id: selectOne.pairingID,
          'options': Number(targetOption),
          allOptions: null
        }]
        let formData = new FormData();
        formData.append('pairings', JSON.stringify(updatePairings));
        await pairingAPIs.updatePairings(formData)
      }
      this.actionSelected = []
      this.getPairedInfluencers(this.campaign.id)
      this.isLoading = false
      this.$swal({
        title: 'Success',
        icon: 'info',
        text: `Successfully Moved.`
      });
    },
    async moveAllOption(option) {
      this.isLoading = true
      for (let selectOne of this.actionSelected) {
        let updatePairings = [{
          id: selectOne.pairingID,
          allOptions: true,
          options: null
        }]
        let formData = new FormData();
        formData.append('pairings', JSON.stringify(updatePairings));
        await pairingAPIs.updatePairings(formData)
      }
      this.actionSelected = []
      this.getPairedInfluencers(this.campaign.id)
      this.isLoading = false
      this.$swal({
        title: 'Success',
        icon: 'info',
        text: `Successfully Moved.`
      });
    }
  }
};
</script>
<style scoped>
.custom-font {
  font-size: 16px;
  font-weight: 500;
  color: #eee;
}
.danger {
  color: black;
  background-color: #fff176;
}
.danger:hover {
  background-color: #ff5722;
}
.not-in-ims {
  text-decoration: line-through;
}
.move-cursor {
  cursor: move;
  float: left;
  margin-top: 25px;
}
.multi-select-checkbox {
  display: inline;
  float: left;
  padding: 0;
  margin-top: 21px;
}
.btn-reload {
  margin-top: 23px;
  padding: 0!important;
  min-width: 10px!important;
}
.page__table tbody td {
  padding: 5px!important;
}
.page__table tbody td .input-field {
  font-size:13px;
}
.deliverable-txt {
  inline-size: 150px;
  overflow-wrap: break-word;
}
.pairing-toolbar-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 0;
}
.pairing-control-row {
  align-items: center;
  margin-bottom: 8px;
}
.pairing-primary-controls,
.pairing-search-controls {
  min-width: 0;
}
.pairing-search-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.pairing-search-controls .v-input {
  flex: 1 1 220px;
  min-width: 180px;
}
.pairing-edit-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.pairing-filter-row {
  align-items: center;
  margin-bottom: 4px;
}
.pairing-table-tools {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 2px;
  padding-right: 0 !important;
}
.pairing-table-search {
  flex: 1 1 auto;
  min-width: 150px;
}
.pairing-toolbar-chip,
.pairing-toolbar-btn,
.pairing-toolbar-download {
  align-items: center;
  display: inline-flex;
  min-height: 32px;
}
.pairing-toolbar-btn {
  margin: 0 !important;
}
.pairing-toolbar-download {
  margin: 0 !important;
}
</style>
<style>
  .page__table .v-simple-checkbox {
    text-align: center
  }
  .page__table tbody td .remark-text {
    display: -webkit-box;
    max-width: 200px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .page__table .multi-select-more-btn {
    background-color: #fff;
    color: #3f3f3f!important;
  }
  .page__table .multi-select-more-btn:hover {
    background: none;
    color: #3F3FFF!important;
    transition: 0.5s;
  }
  .option-btn.v-btn--active {
    background-color: var(--ims-color-secondary)!important;
    color: #fff!important;
  }
  .download-excel-secondary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 64px;
    height: 36px;
    padding: 0 16px;
    border-radius: 4px;
    background-color: #3F3FFF;
    color: #fff!important;
    font-size: 0.875rem;
    font-weight: 500;
    letter-spacing: 0.0892857143em;
    line-height: 1;
    text-decoration: none;
    vertical-align: middle;
    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    transition: box-shadow .28s cubic-bezier(.4, 0, .2, 1), background-color .28s cubic-bezier(.4, 0, .2, 1);
  }
  .download-excel-secondary:hover {
    background-color: #3636d9;
    color: #fff!important;
    text-decoration: none;
    box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%), 0 1px 10px 0 rgb(0 0 0 / 12%);
  }
</style>



// WEBPACK FOOTER //
// ViewPairingModal.vue?efbd4768